(function (jQuery) {
  window.$ = jQuery.noConflict();
})(jQuery);

window.theme = window.theme || {};

/* ================ SLATE ================ */
window.theme = window.theme || {};
window.theme.mobileBreakpoint = 999;
window.theme.prevWidth = window.innerWidth;

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];
  $(document).on('shopify:section:load', this._onSectionLoad.bind(this)).on('shopify:section:unload', this._onSectionUnload.bind(this)).on('shopify:section:select', this._onSelect.bind(this)).on('shopify:section:deselect', this._onDeselect.bind(this)).on('shopify:block:select', this._onBlockSelect.bind(this)).on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = (instance.id === evt.detail.sectionId);

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

window.slate = window.slate || {};

/*** iFrames * * Wrap videos in div to force responsive layout.*/
slate.rte = {
  wrapTable: function() {
    $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
  },

  iframeReset: function() {
    var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
    var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

    $iframeVideo.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="video-wrapper"></div>');
    });

    $iframeReset.each(function() {
      this.src = this.src;
    });
  }
};

window.slate = window.slate || {};

slate.a11y = {

  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /*** If there's a hash in the url, focus the appropriate element */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /*** When an in-page (url w/hash) link is clicked, focus the appropriate element */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /* Traps the focus in a particular container
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).off('focusin');

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /*** Removes the trap of focus in a particular container
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/*** Image Helper Functions * * A collection of functions that help with basic image operations. **/
theme.Images = (function() {

  /*** Preloads an image in memory and uses the browsers cache to store it until needed.
   * @param {Array} images - A list of image urls * @param {String} size - A shopify image size attribute */
  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }
    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /*** Loads and caches an image in the browsers cache. * @param {string} path - An image url */
  function loadImage(path) {
    new Image().src = path;
  }

  /*** Swaps the src of an image for another OR returns the imageURL to the callback function
   * @param image * @param element * @param callback */
  function switchImage(image, element, callback) {
    var size = this.imageSize(element.src);
    var imageUrl = this.getSizedImageUrl(image.src, size);

    if (callback) {
      callback(imageUrl, image, element); // eslint-disable-line callback-return
    } else {
      element.src = imageUrl;
    }
  }

  /*** +++ Useful * Find the Shopify image attribute size ** @param {string} src * @returns {null} */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
    if (match !== null) {
      return match[1];
    } else {
      return null;
    }
  }
  function getSizedImageUrl(src, size) {
    if (size == null) {
      return src;
    }
    if (size === 'master') {
      return this.removeProtocol(src);
    }
    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
    if (match != null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];
      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    }
    return null;
  }
  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }
  return {
    preload: preload, loadImage: loadImage, switchImage: switchImage, imageSize: imageSize, getSizedImageUrl: getSizedImageUrl, removeProtocol: removeProtocol
  };
})();

/*** Currency Helpers */
theme.Currency = (function() {
  var moneyFormat = '${{amount}}';

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision || 2;
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }
    return formatString.replace(placeholderRegex, value);
  }
  return { formatMoney: formatMoney }
})();

/*** Variant Selection scripts */
slate.Variants = (function(){

  /*** Variant constructor ** @param {object} options - Settings from `product.js`*/
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    // UPDATED
    this._updateLowStockWarning(this.currentVariant);

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
    //$('.stickyCart .swatchInput').on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = _.assignIn({}, Variants.prototype, {

    //cartTotalDollars
    /*** Get the currently selected options from add-to-cart form. Works with all form input elements. */
    _getCurrentOptions: function() {
      var currentOptions = _.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');
          currentOption.label = $element.next('.swatchLbl').innerText;
          $("."+currentOption.index).find('.swatchInput[value="'+currentOption.value+'"]').prop("checked", true);
          $("."+currentOption.index).find(".slVariant").text(currentOption.value);
          if (currentOption.value) {
              ($('.stickyCart').find('.swatch-select-opener')).text(currentOption.value.split(' ')[0].toLowerCase());
          }
          // Set size measurement in PDP product details
          const sizeMeasurements = document.querySelectorAll(".prod-detail-size");
          if (sizeMeasurements.length > 0) {
            // remove all non a-z chars including whitespace 
            const lowerOptVal = currentOption?.value?.replace(/[^a-zA-Z]+/g, "").toLowerCase();

            // we only want to update if the current size exists.
            let currentHasSizeMeasurement = false;
            sizeMeasurements?.forEach(size => {
              if (size.classList.contains(lowerOptVal)) {
                currentHasSizeMeasurement = true;
              }
            });
            if (currentHasSizeMeasurement) {
              sizeMeasurements?.forEach(size => {
                size.style.display = "none";
                if (size.classList.contains(lowerOptVal)) {
                  size.style.display = "";
                }
              });
              // if the default selection does not have a size measurement we should display one as well.
            } else {
              let hasPossibleSizeDisplayed = false;
              sizeMeasurements?.forEach(size => {
                if (size.style.display !== "none") {
                  hasPossibleSizeDisplayed = true;
                }
              });
              if (!hasPossibleSizeDisplayed) {
                sizeMeasurements[0].style.display = "";
              }
            }
          }

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = _.compact(currentOptions);

      return currentOptions;
    },

    /*** Find variant based on selected values. *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;

      var found = _.find(variants, function(variant) {
        return selectedValues.every(function(values) {
          return _.isEqual(variant[values.index], values.value);
        });
      });

      return found;
    },
	// Currently, this function assumes 'option2' to always be size
    // This function could be expanded to single out the current size option specifically, if
	// the option indexes would be set to their respective option types, such as 'color', 'size',
    // etc., instead of 'option1', 'option2', etc.
    _getVariantFromOptionsWithoutSize: function() {
    	var selectedOptions = this._getCurrentOptions();
        var selectedOptionsWithoutSize = selectedOptions.filter(function(option) {
  	      return option.index !== 'option2';
	    });
        var variants = this.product.variants;

        return variants.find(function(variant) {
    		switch (selectedOptionsWithoutSize.length) {
    		  case 1: {
    			return variant[selectedOptionsWithoutSize[0].index] === selectedOptionsWithoutSize[0].value;
  			  }
    		  case 2: {
    			[firstOption, secondOption] = selectedOptionsWithoutSize;
    			return (variant[firstOption.index] === firstOption.value && variant[secondOption.index] === secondOption.value);
			  }
    		  default: {
    			return variant[selectedOptions[0].index] === selectedOptions[0].value;
      		  }
            }
	  });
    },
    /*** Event handler for when a variant input changes. */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);
      this.currentVariant = variant;

      //Update DY recommendation context
      this._updateDYTracking();

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }

      // UPDATED
      this._updateLowStockWarning(variant);
    },

    // UPDATED
    _updateLowStockWarning: function(variant) {
      if (!variant){
         return; 
      }
      
      const lowStockEl = document.getElementById("quantity_message");
      if (!lowStockEl){
        return;
      }
      if (variant.inventory_quantity > 3 || variant.inventory_quantity === 0) {
        lowStockEl.style.display = "none";
      } else { 
        lowStockEl.style.display = "block";
      }
    },

    /*** Trigger event when variant image changes */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};
      this.$container.trigger({
        type: 'galleryImageChange',
        variant: variant
      });
      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /*** Trigger event when variant price changes. */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }
      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /*** Trigger event when variant sku changes. */
    _updateSKU: function(variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }
      this.$container.trigger({
        type: 'variantSKUChange',
        variant: variant
      });
    },
     /*** Trigger DY Recommendation Context Update when sku changes. */
     _updateDYTracking: function(variantForDY) {

      if(DY){

        let _vid = [];
        _vid.push(this.currentVariant.id.toString());
        let _url = window.location.protocol + "//" + window.location.host + "/" + window.location.pathname;

        DY.API('spa', {
              context: {
              type: 'PRODUCT',
              data: _vid
              },url: _url, countAsPageview: false

           });

        }
  },

    /*** Update history state for product deeplinking */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /*** Update hidden master select of variant change * @param  {variant} variant - Currently selected variant */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container).val(variant.id);
    }
  });

  return Variants;
})();


/* ================ GLOBAL ================ */

/* ================ MODULES ================ */
window.theme = window.theme || {};

theme.Search = (function() {
  var selectors = {
    search: '.search',
    searchSubmit: '.search__submit',
    searchInput: '.search__input',
    siteHeader: '#shopify-section-header .header-wrap',
    siteHeaderSearchToggle: '.site-header__search-toggle',
    searchDrawer: '.search-bar'
  };

  var classes = {
    focus: 'search--focus'
  };

  function init() {
    if (!$(selectors.siteHeader).length) { return; }

    searchSubmit();

    $(selectors.siteHeaderSearchToggle).on('click', function() {
      $(selectors.searchDrawer).addClass('active');
      $('body').addClass('searchOn');
      $('html').addClass('searchOn');
      $('.search-bar .search-bar__form .search-bar__input').focus();

    });
    $("body").click(function(event ){
      var $target = $(event.target);
      if(!$target.parents().is(selectors.searchDrawer) && !$target.is(selectors.searchDrawer) && !$target.parents().is(selectors.siteHeaderSearchToggle) && !$target.is(selectors.siteHeaderSearchToggle)){
        $(selectors.searchDrawer).removeClass('active');
      	$('body').removeClass('searchOn');
        $('html').removeClass('searchOn');
        $('.search-bar .search-bar__form .search-bar__input').blur();
      }
    });
    $('.search-bar__close').on('click', function() {
      $(selectors.searchDrawer).removeClass('active');
      $('body').removeClass('searchOn');
      $('html').removeClass('searchOn');
      $('.search-bar__form .search-bar__input').blur();
    });

    // Current Ajax request.
    var currentAjaxRequest = null;
    var searchForms = $('form[action="/search"]').each(function() {
      var input = $(this).find('input[name="q"]');
      // Adding a list for showing search results.
      var offSet = input.position().top + input.innerHeight();
      $('<ul class="search-results"></ul>').appendTo($(this)).hide();
      // Listening to keyup and change on the text field within these search forms.
      input.attr('autocomplete', 'off').bind('keyup change', function() {
        var term = $(this).val(),
        	form = $(this).closest('form'),
        	searchURL = '/search?type=product&q=' + term,
        	resultsList = form.find('.search-results');
        if (term.length > 3 && term != $(this).attr('data-old-term')) {
          $(this).attr('data-old-term', term);
          if (currentAjaxRequest != null) currentAjaxRequest.abort();
          currentAjaxRequest = $.getJSON(searchURL + '&view=json', function(data) {
            resultsList.empty();
            if(data.results_count == 0) {
              // resultsList.html('<li><span class="title">No results.</span></li>');
              // resultsList.fadeIn(200);
              resultsList.hide();
            } else {
              // If we have results.
              $.each(data.results, function(index, item) {
                var link = $('<a></a>').attr('href', item.url);
                link.append('<span class="thumbnail"><img src="' + item.thumbnail + '" /></span>');
                link.append('<span class="title">' + item.title + '</span>');
                link.append('<span class="price">' + item.price + '</span>');

                link.wrap('<li></li>');
                resultsList.append(link.parent());
              });
              if(data.results_count > 10) {
                resultsList.append('<span class="view-all-products"><a href="' + searchURL + '">'+ theme.allresult +' (' + data.results_count + ')</a></span>');
              }
              resultsList.fadeIn(200);
            }
          });
        }
      });
    });

      $('.popular-categories-slider').slick({
          dots: false,
          infinite: true,
          speed: 300,
          slidesToShow: 4,
          slidesToScroll: 1,
          responsive: [
              {
                  breakpoint: 1024,
                  settings: {
                      slidesToShow: 3,
                      slidesToScroll: 1
                  }
              },
              {
                  breakpoint: 600,
                  settings: {
                      slidesToShow: 2,
                      slidesToScroll: 1
                  }
              },
              {
                  breakpoint: 480,
                  settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1
                  }
              }
          ]
      });
  }

  function searchSubmit() {
    $(selectors.searchSubmit).on('click', function(evt) {
      var $el = $(evt.target);
      var $input = $el.parents(selectors.search).find(selectors.searchInput);
      if ($input.val().length === 0) {
        evt.preventDefault();
        searchFocus($input);
      }
    });
  }

  return {
    init: init
  };
})();

function isEmailValid($email) {
  var regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  if(!regex.test($email)) {
    return false;
  }else{
    return true;
  }
}
function addEmailValidationError(input, errorText) {
  const form = $(input).closest('form');
  const inputGroup = $(input).closest('.input-group');
  if($(form).find('.errors').length > 0) {
    $(form).find('.errors').html(`<ul><li>${errorText}</li></ul>`);
  } else {
    inputGroup.after(`<div class="errors"><ul><li>${errorText}</li></ul></div>`);
  }
}
function emailValidation(form, input) {
  const email = $(input).val();
  if(!isEmailValid(email)) {
    addEmailValidationError(input, 'Please enter a valid email address');
    return false;
  }
  $(form).find('.errors').remove();
  return true;
}

function setPopupType(type) {
    var cookieName = "popup_success_type";
    $.cookie(cookieName, type, {expires:30, path:'/'});
}

function getPopupType() {
    var cookieName = "popup_success_type";
    var str = String($.cookie(cookieName));
    //$.cookie(cookieName, null, {expires:30, path:'/'});
    return str;
}

function setCartOpenCookie() {
    var cookieName = "wishlist_cart";
    $.cookie(cookieName, 1, {expires:30, path:'/'});
    return true;
}

function getCartOpenCookie() {
    var cookieName = "wishlist_cart";
    var str = String($.cookie(cookieName));
    $.cookie(cookieName, null, {expires:30, path:'/'});
    return str;
}

function showDefaultEmailError () {
  let searchParams = new URLSearchParams(window.location.search);
  const form =  $(`.site-footer #contact_form`);
  if(searchParams.has('contact[tags]') && searchParams.get('contact[tags]') === 'newsletter'
      && searchParams.has('form_type') && searchParams.get('form_type')) {
    const input = form.find(`[name="contact[email]"]`);
    const errors = form.find('.errors > ul > li:visible');
    if(errors.length === 0) {
      addEmailValidationError(input, 'You have already subscribed! or something went wrong. Please, contact our support!');
    }
    setTimeout(() => {  $('html, body').animate({ scrollTop: form.offset().top}, 1000); }, 1000);
  }
}

function showSubscribeNotification () {
  if($.cookie('restockNotificationShow') && $.cookie('restockNotificationShow') === 'true') {
    let searchParams = new URLSearchParams(window.location.search);
    const form =  $(`.site-footer #contact_form`);
    if(!(searchParams.has('customer_posted') && searchParams.get('customer_posted') === 'true')){
      $('#dd-restock-notification-msg').css({display: 'inline-block'});
      $('#dd-restock-notification-msg-success').css({display: 'inline-block'}).addClass('opacity-1');
    }
    $.removeCookie('restockNotificationShow');
  } else {
    $('#dd-restock-notification-msg-success').removeClass('opacity-1');
  }
}

$(document).ready(function () {
    const origin   = window.location.origin;
  if(!origin.includes('blog')) {
    const cookie = $.cookie('blogData') ? JSON.parse($.cookie('blogData')) : {};
    //const customerName = '{{ customer }}' ? {'customerName': '{{ customer.first_name }}'} : {'customerName': false};
    const customerName = (typeof customerNameHead !== 'undefined') && customerNameHead ? {'customerName': customerNameHead} : {'customerName': false};
    const newCookie = Object.assign({}, cookie, customerName);
    $.removeCookie('blogData', {expires: 7, path: '/', domain: 'lagos.com'});
    $.cookie('blogData', JSON.stringify(newCookie), { expires: 7, path: '/', domain: 'lagos.com' });
  }
    showSubscribeNotification ();

    $('.contact-modal-link').magnificPopup({
        type:'inline',
        midClick: true,
        callbacks: {
  			open: function() {
  				setPopupType('header');
  		    }
  		}
    });
    $('.free-ship-modal-opener').magnificPopup({
        type:'inline',
        midClick: true
    });
    $('.close-success-modal').on('click', function(){
        $(this).closest('.success-modal-block').hide();

    });
    $('#dd-restock-notification-msg-success .close-success-modal').on('click', function(){
        $(this).closest('.success-modal-block').removeClass('opacity-1');
    });

  $(document).on('submit', '#contact_form', function (e) {
    const input =  $(this).find('input[name="contact[email]"]');
    if($(input).val().trim() === '') {
      e.preventDefault();
      addEmailValidationError(input, 'Email can`t be blank');
      return false;
    }else if(!emailValidation($(this), input)) {
      e.preventDefault();
    }
  });

  $('.restock-form').on('submit', function (e) {
    const input =  $(this).find('input[name*="email"]');
    const sendSubscribeForm = $(this).find('.become-insider').is(":checked");
    $(this).find('#dd-restock-notification-msg-error').css({ display: 'none'});
    if($(input).val().trim() === '' || !emailValidation($(this), input)) {
      e.preventDefault();
      $(this).find('#dd-restock-notification-msg-error').css({ display: 'inline-block'});
      return false;
    }else if(sendSubscribeForm) {
      let sendContactCounter = 0;
      const sendContactForm = (stopIntervalIndex) => {
        if ($('#dd-restock-notification-msg-success').css('display') === 'block') {
          $.cookie('restockNotificationShow', 'true');
          $('.site-footer #contact_form input[name="contact[email]"]').val($(input).val());
          $('.site-footer #contact_form').submit();
          clearInterval(stopIntervalIndex);
        }
      };
      let intervalIndex = setInterval(() => {
          sendContactForm(intervalIndex);
        if(sendContactCounter++ > 10) {
          clearInterval(intervalIndex);
        }
      }, 300);
    } else {
      $('#dd-restock-notification-msg-success').addClass('opacity-1');
    }
  });

  $('#contact_form input[name="contact[email]"]').on('blur', function () {
    if($(this).val().trim() !== '') {
      emailValidation($(this).closest('form'), $(this));
    } else {
      $(this).closest('form').find('.errors').remove();
    }
  });

  showDefaultEmailError();

  var t = getCartOpenCookie();
  if (t == 1) {
    $("#header-cart").toggleClass('cart-open');
    if ($("#header-cart").hasClass('cart-open')) {
      focusMiniCart();
    } else {
      focusMiniCart(false);
    }
    $("html").addClass("cartOn");
  }
});

(function() {
  var selectors = {
    backButton: '.return-link'
  };

  var $backButton = $(selectors.backButton);

  if (!document.referrer || !$backButton.length || !window.history.length) {
    return;
  }

  $backButton.one('click', function(evt) {
    evt.preventDefault();

    var referrerDomain = urlDomain(document.referrer);
    var shopDomain = urlDomain(window.location.href);

    if (shopDomain === referrerDomain) {
      history.back();
    }

    return false;
  });

  function urlDomain(url) {
    var anchor = document.createElement('a');
    anchor.ref = url;

    return anchor.hostname;
  }
})();

theme.Slideshow = (function(){
  this.$slideshow = null;
  var classes = {
    wrapper: 'slideshow-wrapper',
    slideshow: 'slideshow',
    currentSlide: 'slick-current',
    video: 'slideshow__video',
    videoBackground: 'slideshow__video--background',
    closeVideoBtn: 'slideshow__video-control--close',
    pauseButton: 'slideshow__pause',
    isPaused: 'is-paused'
  };

  $(window).on('load delayed-resize', function (e, resizeEvent) {
  	var SlideshowHeight = $(window).height();
    $(".slideshow-wrapper .slideshow--full").height(SlideshowHeight-35);
  });

  function slideshow(el) {
    this.$slideshow = $(el);
    this.$wrapper = this.$slideshow.closest('.' + classes.wrapper);
    this.$pause = this.$wrapper.find('.' + classes.pauseButton);

    this.settings = {
      accessibility: true,
      arrows: true,
      dots: true,
      fade: true,
      rtl:theme.rtl,
      draggable: true,
      touchThreshold: 20,
      autoplay: this.$slideshow.data('autoplay'),
      autoplaySpeed: this.$slideshow.data('speed')
    };

    this.$slideshow.on('beforeChange', beforeChange.bind(this));
    this.$slideshow.on('init', slideshowA11y.bind(this));
    this.$slideshow.slick(this.settings);
    this.$pause.on('click', this.togglePause.bind(this));
  }

  function slideshowA11y(event, obj) {
    var $slider = obj.$slider;
    var $list = obj.$list;
    var $wrapper = this.$wrapper;
    var autoplay = this.settings.autoplay;

    // Remove default Slick aria-live attr until slider is focused
    $list.removeAttr('aria-live');

    // When an element in the slider is focused
    // pause slideshow and set aria-live.
    $wrapper.on('focusin', function(evt) {
      if (!$wrapper.has(evt.target).length) {
        return;
      }

      $list.attr('aria-live', 'polite');

      if (autoplay) {
        $slider.slick('slickPause');
      }
    });

    // Resume autoplay
    $wrapper.on('focusout', function(evt) {
      if (!$wrapper.has(evt.target).length) {
        return;
      }

      $list.removeAttr('aria-live');

      if (autoplay) {
        // Manual check if the focused element was the video close button
        // to ensure autoplay does not resume when focus goes inside YouTube iframe
        if ($(evt.target).hasClass(classes.closeVideoBtn)) {
          return;
        }
        $slider.slick('slickPlay');
      }
    });

    // Add arrow key support when focused
    if (obj.$dots) {
      obj.$dots.on('keydown', function(evt) {
        if (evt.which === 37) {
          $slider.slick('slickPrev');
        }

        if (evt.which === 39) {
          $slider.slick('slickNext');
        }

        // Update focus on newly selected tab
        if ((evt.which === 37) || (evt.which === 39)) {
          obj.$dots.find('.slick-active button').focus();
        }
      });
    }
  }

  function beforeChange(event, slick, currentSlide, nextSlide) {
    var $slider = slick.$slider;
    var $currentSlide = $slider.find('.' + classes.currentSlide);
    var $nextSlide = $slider.find('.slideshow__slide[data-slick-index="' + nextSlide + '"]');

    if (isVideoInSlide($currentSlide)) {
      var $currentVideo = $currentSlide.find('.' + classes.video);
      var currentVideoId = $currentVideo.attr('id');
      theme.SlideshowVideo.pauseVideo(currentVideoId);
      $currentVideo.attr('tabindex', '-1');
    }

    if (isVideoInSlide($nextSlide)) {
      var $video = $nextSlide.find('.' + classes.video);
      var videoId = $video.attr('id');
      var isBackground = $video.hasClass(classes.videoBackground);
      if (isBackground) {
        theme.SlideshowVideo.playVideo(videoId);
      } else {
        $video.attr('tabindex', '0');
      }
    }
  }

  function isVideoInSlide($slide) {
    return $slide.find('.' + classes.video).length;
  }

  slideshow.prototype.togglePause = function() {
    var slideshowSelector = getSlideshowId(this.$pause);
    if (this.$pause.hasClass(classes.isPaused)) {
      this.$pause.removeClass(classes.isPaused);
      $(slideshowSelector).slick('slickPlay');
    } else {
      this.$pause.addClass(classes.isPaused);
      $(slideshowSelector).slick('slickPause');
    }
  };

  function getSlideshowId($el) {
    return '#Slideshow-' + $el.data('id');
  }

  return slideshow;
})();


/* ================ TEMPLATES ================ */
(function() {
  var $filterBy = $('#BlogTagFilter');

  if (!$filterBy.length) {
    return;
  }

  $filterBy.on('change', function() {
    location.href = $(this).val();
  });

})();

window.theme = theme || {};

theme.customerTemplates = (function() {

  function initEventListeners() {
    // Show reset password form
    $('#RecoverPassword').on('click', function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });

    // Hide reset password form
    $('#HideRecoverPasswordLink').on('click', function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });

  // Show password
  $('.toggle-password').on('click', function() {
      $(this).find('.fa').toggleClass('fa-eye fa-eye-slash');
      var input = $($(this).closest('.input-container').find('#CustomerPassword'));
      if (input.attr('type') == 'password') {
          input.attr('type', 'text');
      } else {
          input.attr('type', 'password');
      }
  });
  }

  /***  Show/Hide recover password form **/
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /*** Show reset password success message **/
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }
    // show success message
    $('#ResetSuccess').removeClass('hide');
  }

  /** Show/hide customer address forms **/
  function customerAddressForm() {
    var $newAddressForm = $('#AddressNewForm');

    if (!$newAddressForm.length) {
      return;
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
        hideElement: 'AddressProvinceContainerNew'
      });
    }

    // Initialize each edit form's country/province selector
    $('.address-country-option').each(function() {
      var formId = $(this).data('form-id');
      var countrySelector = 'AddressCountry_' + formId;
      var provinceSelector = 'AddressProvince_' + formId;
      var containerSelector = 'AddressProvinceContainer_' + formId;

      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector
      });
    });

    // Toggle new/edit address forms
    $('.address-new-toggle').on('click', function() {
      $newAddressForm.toggleClass('hide');
    });

    $('.address-edit-toggle').on('click', function() {
      var formId = $(this).data('form-id');
      $('#EditAddress_' + formId).toggleClass('hide');
    });

    $('.address-delete').on('click', function() {
      var $el = $(this);
      var formId = $el.data('form-id');
      var confirmMessage = $el.data('confirm-message');

      // eslint-disable-next-line no-alert
      if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
        Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
      }
    });
  }

  /****  Check URL for reset password hash **/
  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  return {
    init: function() {
      checkUrlHash(); initEventListeners(); resetPasswordSuccess(); customerAddressForm();
    }
  };
})();

var mobileNavigationPosition = function(){
    var headerEntireHeight = $('.shopify-section .header-wrap').outerHeight();

    $('.mobile-nav-wrapper').css({'top': headerEntireHeight, 'max-height' : $(window).height() - headerEntireHeight});
    $('.modalOverly').css('top', headerEntireHeight);
}
var desktopNavDropSize = function(){
    var navDrop = $('.site-nav li.lvl1 div.megamenu');

    if (navDrop.length > 0) {
        if($(window).prop('innerWidth') > 998){
            navDrop.each(function () {
                $(this).css({"max-height": ($(window).height() - $('.shopify-section .header-wrap').outerHeight())})
            })
        } else {
            navDrop.removeAttr('style');
        }
    }
}
var navImageSlider = function(){
    var sliderWrapper = $('#siteNav .nav-slider');

    if (sliderWrapper.length > 0) {
        if($(window).prop('innerWidth') > 998){
            sliderWrapper.each(function () {
                var navSlider = $(this).children('.slider'),
                    slidesVisible = navSlider.data('slides'),
                    slidesAutoplay = navSlider.data('autoplay'),
                    slidesAutoplaySpeed = navSlider.data('autoplay-speed');

                $(navSlider).not('.slick-initialized').slick({
                    slidesToShow: slidesVisible,
                    slidesToScroll: 1,
                    autoplay: slidesAutoplay,
                    autoplaySpeed: slidesAutoplaySpeed,
                });
            })
        }
    }
}
var swatchSlider = function(container, slides){
    var slider = $(container);

    if (slider.length > 0) {
        slider.each(function () {
            var items = $(this).find('.swatch');
            if(items.length > slides){
                $(this).slick({
                    slidesToShow: slides,
                    slidesToScroll: 1,
                    infinite: true
                });
            }
        })
    }
}
var mobileColumnsSlider = function(){
    var slider = $('.collection-columns .grid--uniform .grid');

    if (slider.length > 0) {
        slider.each(function () {
            $(slider).slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false
            });
        })
    }
}

var centeredSlickArrows = function(carousel, imageContainer){
    setTimeout(function(){
        $(carousel).each(function () {
            var slickSliderBlock = $(this),
                sliderItems = slickSliderBlock.find(imageContainer),
                arrows = slickSliderBlock.find('.slick-arrow'),
                topPos = sliderItems.outerHeight()/2 - arrows.outerHeight()/2;

            if(sliderItems.length > 0){
                arrows.removeAttr('style');
                arrows.css({"top": topPos }).addClass('loaded');
            }
        })
    },500);
}

var mobileColumnsSliderOro = function(){
  var slider = $('.grid-item-columns.mobile-carousel');


  if (slider.length > 0) {
    slider.each(function () {
      $(slider).slick({
        slidesToShow: 1.5,
        slidesToScroll: 1,
        infinite:false
      });
    })
  }
}

var recentlyViewedSlider = function(){
    var sliderRelatedPr = $(".recent-products"),
        sliderRelatedds = $(sliderRelatedPr).attr('data-ds'),
        sliderRelatedtb = $(sliderRelatedPr).attr('data-tb'),
        sliderRelatedmb = $(sliderRelatedPr).attr('data-mb');

    if ($('.recent-products .grid-products.carousel').length > 0){
        $('.recent-products .grid-products.carousel').slick({
            dots: false,
            infinite: true,
            slidesToShow:sliderRelatedds,
            slidesToScroll: 1,
            autoplay: false,
            rtl: theme.rtl,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: sliderRelatedtb,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: sliderRelatedmb,
                        slidesToScroll: 1
                    }
                }
            ]
        });
        // centeredSlickArrows('.tab-content-box .grid-products', '.image');
    }
}
var tabsCarouselUpdate = function(){
    if ($('.tabs-section').length > 0){
        $('.tabs-section .tab-content-box').each(function () {
            if ($(this).hasClass('active')){
                return
            } else {
                $(this).removeClass('active');
            }
        });

        $('.product-tabs-list .tab-opener').on('click', function (e) {
            var targetTabID = $(this).data('target');
            var targetTab = document.getElementById(targetTabID);

            e.preventDefault();
            if ($(this).parent().hasClass('active')) {
                return
            } else {
                $('.product-tabs-list > li').removeClass('active');
                $('.tabs-section .tab-content-box').removeClass('active');
                $(this).parent().addClass('active');
                $(targetTab).addClass('active');

                if($('#recently-viewed-products:visible')){
                    // recentlyViewedSlider();
                }
            }
        })
    }
}


var contactsSlider = function(){
    if ($('.contacts-container').length > 0){
        $('.contacts-container').slick({
            dots: true,
            arrows: false,
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: false,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    }
}

var gridSectionSlider = function(){
    if ($('.grid-section-carousel').length > 0){
        $('.grid-section-carousel').slick({
            dots: false,
            arrows: true,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false
        });
    }
}
var heroSectionSlider = function(){
    if ($('.hero-carousel-wrapper .carousel').length > 0){
        $('.hero-carousel-wrapper .carousel').slick({
            dots: false,
            arrows: true,
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            autoplay: false,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                }
            ]
        });
    }
}

var customerCareSlider = function(){
  if ($('.customer-care-columns-container').length > 0){
    $('.customer-care-columns-container').slick({
      dots: true,
      arrows: false,
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }
}


/*================ SECTIONS ================*/
// Navigation Menu
window.theme = window.theme || {};
theme.navigationmenu = (function() {
	var selectors = {
      	html: 'html',
      	body: 'body',
      	sitenav: '#siteNav',
      	navLinks: '#siteNav .lvl1 > a',
      	menuToggle: '.js-mobile-nav-toggle',
      	mobilenav: '.mobile-nav-wrapper',
      	menuLinks: '#MobileNav .ad',
      	closemenu: '.closemobileMenu'
	};

  	$(selectors.navLinks).each(function(){
        if($(this).attr('href') == window.location.pathname) $(this).addClass('active');
    })

  	$(selectors.menuToggle).on("click",function(){
      mobileNavigationPosition();
      html: 'html',
      $(selectors.mobilenav).toggleClass("active");
      $(selectors.html).toggleClass("menuOn");
      $(selectors.menuToggle).toggleClass('mobile-nav--open mobile-nav--close');
    });

    $(selectors.closemenu).on("click",function(){
      html: 'html',
      $(selectors.mobilenav).toggleClass("active");
      $(selectors.html).toggleClass("menuOn");
      $(selectors.menuToggle).toggleClass('mobile-nav--open mobile-nav--close');
    });
    $("body").click(function(event){
      var $target = $(event.target);
      if(!$target.parents().is(selectors.mobilenav) && !$target.parents().is(selectors.menuToggle) && !$target.is(selectors.menuToggle)){
          $(selectors.mobilenav).removeClass("active");
          $(selectors.html).removeClass("menuOn");
          $(selectors.menuToggle).removeClass('mobile-nav--close').addClass('mobile-nav--open');
      }
    });
    $('.contact-modal-link').on('click', function () {
        if($(window).prop('innerWidth') < 999) {
            $('.mobile-nav-wrapper').removeClass('active');
            $('html').removeClass("menuOn");
            $('.js-mobile-nav-toggle').removeClass('mobile-nav--close').addClass('mobile-nav--open');
        }
    })
	$(selectors.menuLinks).on('click', function(e) {
		e.preventDefault();
		$(this).toggleClass('ad-angle-down-l ad-angle-up-l');
        $(this).parent().toggleClass('active-menu');
        $(this).parent().next().slideToggle();
    });
})();

$(window).resize(function() {
    mobileNavigationPosition();
    desktopNavDropSize();
    navImageSlider();
    centeredSlickArrows('.carousel', '.grid-view-item__link, .image-container-box, .image');
});

window.theme = window.theme || {};
theme.Cart = (function() {
  var selectors = {
    edit: '.js-edit-toggle'
  };
  var config = {
    showClass: 'cart__update--show',
    showEditClass: 'cart__edit--active',
    cartNoCookies: 'cart--no-cookies'
  };

  function Cart(container) {
    this.$container = $(container);
    this.$edit = $(selectors.edit, this.$container);

    if (!this.cookiesEnabled()) {
      this.$container.addClass(config.cartNoCookies);
    }

    this.$edit.on('click', this._onEditClick.bind(this));

    // Shipping Calculator
    if($("#shipping-calculator").length) {
      Shopify.Cart.ShippingCalculator.show({
        submitButton: theme.strings.shippingCalcSubmitButton,
        submitButtonDisabled: theme.strings.shippingCalcSubmitButtonDisabled,
        customerIsLoggedIn: theme.strings.shippingCalcCustomerIsLoggedIn,
        moneyFormat: theme.strings.moneyFormat
      });
    }

      // RELATED PRODUCT SLIDER
      var sliderRelatedPrCart = $("#cart-related-products").find(".related-product"),
          sliderRelateddsCart = $(sliderRelatedPrCart).attr('data-ds'),
          sliderRelatedtbCart = $(sliderRelatedPrCart).attr('data-tb'),
          sliderRelatedmbCart = $(sliderRelatedPrCart).attr('data-mb');

      $('.related-product .productSlider').slick({
          dots: false,
          infinite: true,
          slidesToShow:sliderRelateddsCart,
          slidesToScroll: 1,
          autoplay: false,
          rtl: theme.rtl,
          responsive: [
              {
                  breakpoint: 1024,
                  settings: {
                      slidesToShow: sliderRelatedtbCart,
                      slidesToScroll: 1,
                  }
              },
              {
                  breakpoint: 767,
                  settings: {
                      slidesToShow: sliderRelatedmbCart,
                      slidesToScroll: 1
                  }
              }
          ]
      });
  }

  Cart.prototype = _.assignIn({}, Cart.prototype, {
    onUnload: function() {
      this.$edit.off('click', this._onEditClick);
    },

    _onEditClick: function(evt) {
      var $evtTarget = $(evt.target);
      var $updateLine = $('.' + $evtTarget.data('target'));

      $evtTarget.toggleClass(config.showEditClass);
      $updateLine.toggleClass(config.showClass);
    },

    cookiesEnabled: function() {
      var cookieEnabled = navigator.cookieEnabled;

      if (!cookieEnabled){
        document.cookie = 'testcookie';
        cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
      }
      return cookieEnabled;
    }
  });

  return Cart;
})();

window.theme = window.theme || {};

theme.Filters = (function() {
  var constants = {
    SORT_BY: 'sort_by'
  };
  var selectors = {
    sortSelection: '.filters-toolbar__input--sort',
    defaultSort: '.collection-header__default-sort'
  };

  function Filters(container) {
    var $container = this.$container = $(container);

    this.$sortSelect = $(selectors.sortSelection, $container);
    this.$selects = $(selectors.filterSelection, $container).add($(selectors.sortSelection, $container));
    this.defaultSort = this._getDefaultSortValue();
    this._resizeSelect(this.$selects);
    this.$selects.removeClass('hidden');
    this.$sortSelect.on('change', this._onSortChange.bind(this));
  }

  Filters.prototype = _.assignIn({}, Filters.prototype, {
    _onSortChange: function(evt) {
      var sort = this._sortValue();
      if (sort.length) {
        window.location.search = sort;
      } else {
        // clean up our url if the sort value is blank for default
        window.location.href = window.location.href.replace(window.location.search, '');
      }
      this._resizeSelect($(evt.target));
    },

    _getSortValue: function() {
      return this.$sortSelect.val() || this.defaultSort;
    },

    _getDefaultSortValue: function() {
      return $(selectors.defaultSort, this.$container).val();
    },

    _sortValue: function() {
      var sort = this._getSortValue();
      var query = '';

      if (sort !== this.defaultSort) {
        query = constants.SORT_BY + '=' + sort;
      }

      return query;
    },

    _resizeSelect: function($selection) {
      $selection.each(function() {
        var $this = $(this);
        var arrowWidth = 10;
        // create test element
        var text = $this.find('option:selected').text();
        var $test = $('<span>').html(text);

        // add to body, get width, and get out
        $test.appendTo('body');
        var width = $test.width();
        $test.remove();

        // set select width
        $this.width(width + arrowWidth);
      });
    },

    onUnload: function() {
      this.$sortSelect.off('change', this._onSortChange);
    }
  });

  return Filters;
})();

window.theme = window.theme || {};

theme.HeaderSection = (function() {
  function Header(){
    theme.Search.init();

    $(".site-header__cart").click(function(i) {
		i.preventDefault();
		$("#header-cart").toggleClass('cart-open');
        $("html").addClass("cartOn");
        focusMiniCart();
	});
  	// Hide Cart on document click
    $("body").click(function(event ){
      var $target = $(event.target);
      if(!$target.parents().is(".site-cart, #header-cart") && !$target.is(".site-cart, #header-cart")){
          focusMiniCart(false,false);
          $("html").removeClass("cartOn");
          $("#header-cart").removeClass('cart-open');
      }
    });
      $("#header-cart .close-cart, #header-cart .btn-continue").on('click', function() {
          focusMiniCart(false);
          $("html").removeClass("cartOn");
          $("#header-cart").removeClass('cart-open');
      });
  }

  return Header;
})();

theme.Maps = (function() {
  var config = {
    zoom: 14
  };
  var apiStatus = null;
  var mapsToLoad = [];
  var key = theme.mapKey ? theme.mapKey : '';

  function Map(container) {
    this.$container = $(container);

    if (apiStatus === 'loaded') {
      this.createMap();
    } else {
      mapsToLoad.push(this);

      if (apiStatus !== 'loading') {
        apiStatus = 'loading';
        if (typeof window.google === 'undefined') {
          $.getScript('https://maps.googleapis.com/maps/api/js?key=' + key)
            .then(function() {
              apiStatus = 'loaded';
              initAllMaps();
            });
        }
      }
    }
  }

  function initAllMaps() {
    // API has loaded, load all Map instances in queue
    $.each(mapsToLoad, function(index, instance) {
      instance.createMap();
    });
  }

  function geolocate($map) {
    var deferred = $.Deferred();
    var geocoder = new google.maps.Geocoder();
    var address = $map.data('address-setting');

    geocoder.geocode({address: address}, function(results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status);
      }

      deferred.resolve(results);
    });

    return deferred;
  }

  Map.prototype = _.assignIn({}, Map.prototype, {
    createMap: function() {
      var $map = this.$container.find('.map-section__container');

      return geolocate($map)
        .then(function(results) {
          var mapOptions = {
            zoom: config.zoom,
            center: results[0].geometry.location,
            disableDefaultUI: true
          };

          var map = this.map = new google.maps.Map($map[0], mapOptions);
          var center = this.center = map.getCenter();

          //eslint-disable-next-line no-unused-vars
          var marker = new google.maps.Marker({
            map: map,
            position: map.getCenter()
          });

          google.maps.event.addDomListener(window, 'resize', $.debounce(250, function() {
            google.maps.event.trigger(map, 'resize');
            map.setCenter(center);
          }));
        }.bind(this))
        .fail(function() {
          var errorMessage;

          switch (status) {
            case 'ZERO_RESULTS':
              errorMessage = theme.strings.addressNoResults;
              break;
            case 'OVER_QUERY_LIMIT':
              errorMessage = theme.strings.addressQueryLimit;
              break;
            default:
              errorMessage = theme.strings.addressError;
              break;
          }

          $map
            .parent()
            .addClass('page-width map-section--load-error')
            .html('<div class="errors text-center">' + errorMessage + '</div>');
        });
    },

    onUnload: function() {
      google.maps.event.clearListeners(this.map, 'resize');
    }
  });

  return Map;
})();

// UPDATED
function parseProduct(el) {
  const product = JSON.parse(el);
  product.variants = product.variants.map(variant => {
    variant.inventory_quantity = window
      ?.lagosProductVariants
      ?.find(el => el.id === variant.id)
      ?.inventory_quantity 
      || 0;
    return variant;
  });
  return product;
}

// Global function called by Google on auth errors.
// Show an auto error message on all map instances.
// eslint-disable-next-line camelcase, no-unused-vars
function gm_authFailure() {
  $('.map-section').addClass('map-section--load-error');
  $('.map-section__container').remove();
  $('.map-section__link').remove();
  $('.map-section__overlay').after('<div class="errors text-center">' + theme.strings.authError + '</div>');
}

/* eslint-disable no-new */
theme.Product = (function() {
  function Product(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');

    this.settings = {
      // Breakpoints from src/stylesheets/global/variables.scss.liquid
      mediaQueryMediumUp: 'screen and (min-width: 750px)',
      mediaQuerySmall: 'screen and (max-width: 749px)',
      bpSmall: false,
      enableHistoryState: $container.data('enable-history-state') || false,
      imageSize: null,
      imageZoomSize: null,
      namespace: '.slideshow-' + sectionId,
      sectionId: sectionId,
      sliderActive: false,
      zoomEnabled: false
    };

    this.selectors = {
      addToCart: '#AddToCart-' + sectionId,
      addToCartText: '#AddToCartText-' + sectionId,
      comparePrice: '#ComparePrice-' + sectionId,
      originalPrice: '#ProductPrice-' + sectionId,
      saveAmount:	'#SaveAmount-' + sectionId,
      discountBadge:	'.discount-badge',
      SKU: '.variant-sku',
      originalPriceWrapper: '.product-price__price-' + sectionId,
      originalSelectorId: '#ProductSelect-' + sectionId,
      productFeaturedImage: '.FeaturedImage-' + sectionId,
      productImageWrap: '.FeaturedImageZoom-' + sectionId,
      productPrices: '.product-single__price-' + sectionId,
      productThumbImages: '.product-single__thumbnail--' + sectionId,
      productThumbs: '.product-single__thumbnails-' + sectionId,
      saleClasses: 'product-price__sale product-price__sale--single',
      saleLabel: '.product-price__sale-label-' + sectionId,
      singleOptionSelector: '.single-option-selector-' + sectionId
    }

    // change variant on image sections
    thumbnails = $('.product-single__thumbnail-image');
    if (thumbnails.length) {
      thumbnails.bind('click', function() {
        var arrImage = $(this).attr('src').split('?')[0].split('.');
        var strExtention = arrImage.pop();
        var strRemaining = arrImage.pop().replace(/_[a-zA-Z0-9@]+$/,'');
        var strNewImage = arrImage.join('.')+"."+strRemaining+"."+strExtention;
        if (typeof variantImages[strNewImage] !== 'undefined') {
          productOptions.forEach(function (value, i) {
            optionValue = variantImages[strNewImage]['option-'+i];
            if (optionValue !== null && $('.single-option-selector:eq('+i+') option').filter(function() { return $(this).text() === optionValue }).length) {
              $(".swatch-"+i).find('.swatchInput[value="'+optionValue+'"]').prop( "checked", true );
              $('.single-option-selector:eq('+i+')').val(optionValue).trigger('change');
            }
          });
        }
      });
    }

    //product video
    if($('.popup-video').length){
      $('.popup-video').magnificPopup({
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false
      });
    }

    // Orders Message
    var orderLimit = $(".orderMsg").attr('data-user'),
        orderTime = $(".orderMsg").attr('data-time');
    $(".orderMsg .items").text(Math.floor((Math.random() * orderLimit) + 1));
    $(".orderMsg .time").text(Math.floor((Math.random() * orderTime) + 5));

    // Visotore Message
    var userLimit = $(".userViewMsg").attr('data-user'),
        userTime = $(".userViewMsg").attr('data-time');
    $(".stickyCart .swatch-container .swatchInput").on('change', function(e){
      let currentVariant = false;
      if (!$.isEmptyObject(Shopify.optionsMap) && this.id.includes('swatch-0-')) {
        let primaryOptionVal = this.value;
        if($(".stickyCart .swatch-container input[id^=swatch-1-]").length) {

          for (i=0; i < currentProduct.variants.length; i++) {
            if (currentProduct.variants[i].hasOwnProperty('option1') && currentProduct.variants[i].option1 == primaryOptionVal) {
              let input = $('.stickyCart #swatch-1-' + currentProduct.variants[i].option2)[0];
              $(input).attr('data-val', currentProduct.variants[i].id);
              $(input).attr('data-title', currentProduct.variants[i].title);
              $(input).attr('data-price', Shopify.formatMoney(currentProduct.variants[i].price).replace(".00", ""));
              if (currentProduct.variants[i].available) {
                $(input).parent().removeClass('soldout');
              } else {
                $(input).parent().addClass('soldout');
              }
            }
          }

        };
      }
      if (currentProduct) {
        for (i=0; i < currentProduct.variants.length; i++) {
          if ($(this).attr('data-val') == currentProduct.variants[i].id) {
            currentVariant = currentProduct.variants[i];
            break;
          }
        }
      }

      var value = $(this).attr('data-val'),
      number = $(this).attr('data-no'),
      price = $(this).attr('data-price');
      $(".stickyCart .selectbox").val(value).trigger('change');

      $(".stickyPrice").text(price);

      //this.productvariants = JSON.parse(document.getElementById('ProductJson-' + sectionId).innerHTML);
      let productVariants = currentProduct.variants;

      if (!currentVariant) {
        currentVariant = productVariants[number];
      }

      $(this).closest('.swatch-holder').removeClass('swatch-dropdown-open');
      ($(this).closest('.swatch-holder').find('.swatch-select-opener')).text($(this).next('.swatchLbl').text());

      let frodFormGift = $(".product-form-product-template_gift-card");
      if(frodFormGift.length > 0) {
        let curVal = $(this).val();
        frodFormGift.find('.single-option-selector-product-template_gift-card option[value= "'+ curVal +'"]').prop("selected", true).trigger('change');
      }
    })
      $(".uersView").text(Math.floor((Math.random() * userLimit)));

    setInterval(function(){
    	$(".uersView").text(Math.floor((Math.random() * userLimit)));
	}, userTime);

    $(".stickyOptions .selectedOpt").on('click', function(){
		$(".stickyOptions ul").slideToggle("fast");
    });

    $('.stickyCart .swatch-select-opener').on('click', function (e){
      const selectOpener = $(this);
      const selectContainer = selectOpener.closest('.swatch-holder');
      e.preventDefault();

      if(selectContainer.hasClass('swatch-dropdown-open')){
        selectContainer.removeClass('swatch-dropdown-open')
      } else {
        selectContainer.addClass('swatch-dropdown-open')
      }
    })

    $(document).on('click', function(e) {
      const container = $('.stickyCart .swatch-holder');
      if (!container.is(e.target) && !container.has(e.target).length) {
        container.removeClass('swatch-dropdown-open');
      }
    });
    $(".stickyOptions .vrOpt").on('click', function(e){
		var value = $(this).attr('data-val'),
            number = $(this).attr('data-no'),
            text = $(this).text();
      	$(".selectedOpt").text(text);
      	$(".stickyCart .selectbox").val(value).trigger('change');
      	$(".stickyOptions ul").slideUp("fast");
      	this.productvariants = JSON.parse(document.getElementById('ProductJson-' + sectionId).innerHTML);
    });

    var tabs = this.tabs = '#ProductSection-' + sectionId + ' .tablink';
    $(tabs).on('click', function(e){
      e.preventDefault();
        $(this).parent().addClass("active");
        $(this).parent().siblings().removeClass("active");
        var tab = $(this).attr("href");
        $(".tab-content").not(tab).css("display", "none");
        $(tab).fadeIn();
      	if($(window).width()<767) {
          var tabposition = $(this).offset() + $('.header-wrap').outerHeight();
          $("html, body").animate({ scrollTop: tabposition.top }, 700);
        }
    });

    $('.product-tabs li:first-child').addClass("active");
	$('.tab-container h3:first-child + .tab-content').show();


    $('.sizelink').magnificPopup({
  		type:'inline',
  		midClick: true
	});

  $('.ring-sizer-open-link').magnificPopup({
    type: 'inline',
    midClick: true,
    closeOnBgClick: false,
  });

     $('.emaillink').magnificPopup({
  		type:'inline',
  		midClick: true,
  		callbacks: {
  			open: function() {
  				setPopupType('pdp');
          $('#globo-formbuilder-38280').find('#38280-textarea').val("Style #: "+productSku);
  		    }
  		}
	});

    // RELATED PRODUCT SLIDER
    var sliderRelatedPr = $container.find(".related-product"),
    	sliderRelatedds = $(sliderRelatedPr).attr('data-ds'),
    	sliderRelatedtb = $(sliderRelatedPr).attr('data-tb'),
    	sliderRelatedmb = $(sliderRelatedPr).attr('data-mb');

    $('.related-product .productSlider').slick({
      dots: false,
      infinite: true,
      slidesToShow:sliderRelatedds,
      slidesToScroll: 1,
      autoplay: false,
      rtl: theme.rtl,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: sliderRelatedtb,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: sliderRelatedmb,
            slidesToScroll: 1
          }
        }
      ]
    });
    $('.jdgm-rev-widg__reviews').slick({
      dots: true,
      arrows: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });

    $(window).on('load delayed-resize', function (e, resizeEvent) {
  		productGridView('ProductSection-'+sectionId);
    });

    var stickyProductDetails = function() {
        let productMainContainer = $(".grid.product-single");
        let productInfo = $(".product-description-wrap");

        if($(window).width() > 767) {
            if($(window).scrollTop() + $('.header-wrap').outerHeight() > productMainContainer.offset().top) {
                productInfo.css('top', '146px');
            }
        } else {
            productInfo.removeAttr('style');
        }
    }

    $(window).on('scroll', function () {
      stickyProductDetails();
    });

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$('#ProductJson-' + sectionId).html()) {
      return;
    }

    // UPDATED
    // this.productSingleObject = JSON.parse(document.getElementById('ProductJson-' + sectionId).innerHTML);
    this.productSingleObject = parseProduct(document.getElementById('ProductJson-' + sectionId).innerHTML);

    this.settings.zoomEnabled = $(this.selectors.productFeaturedImage).hasClass('js-zoom-enabled');
    const urlContainer = $(this.selectors.productFeaturedImage).data('src') ||$(this.selectors.productFeaturedImage).attr('src');
    this.settings.imageSize = theme.Images.imageSize(urlContainer);
    if (this.settings.zoomEnabled) {
      this.settings.imageZoomSize = theme.Images.imageSize($(this.selectors.productImageWrap).data('zoom'));
    }

    this._initBreakpoints();
    this._stringOverrides();
    this._initVariants();
    this._initImageSwitch();
    this._initmainimageSlider();
    this._initThumbnailSlider();
    this._initImagesByGemstone({variant: this.variants.currentVariant});
    this._setActiveThumbnail();
    this._initURLCopy();
    this._initGropedProductPopup();
    this._updateGalleryImages({variant: this.variants.currentVariant});


    // Pre-loading product images to avoid a lag when a thumbnail is clicked, or
    // when a variant is selected that has a variant image
   	theme.Images.preload(this.productSingleObject.images, this.settings.imageSize);
  }

  Product.prototype = _.assignIn({}, Product.prototype, {
    _stringOverrides: function() {
      theme.productStrings = theme.productStrings || {};
      $.extend(theme.strings, theme.productStrings);
    },

    _initBreakpoints: function() {
      var self = this;

      enquire.register(this.settings.mediaQuerySmall, {
        match: function() {
          // destroy image zooming if enabled
          if (self.settings.zoomEnabled) {
            _destroyZoom($(self.selectors.productImageWrap));
          }

          self.settings.bpSmall = true;
        },
        unmatch: function() {
          self.settings.bpSmall = false;
        }
      });

      enquire.register(this.settings.mediaQueryMediumUp, {
        match: function() {

          if (self.settings.zoomEnabled) {
            $(self.selectors.productImageWrap).each(function(){
              var $this = $(this);
              _enableZoom($this);
            });
          }
        }
      });
    },

    _initVariants: function() {
      var options = {
        $container: this.$container,
        enableHistoryState: this.$container.data('enable-history-state') || false,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
        product: this.productSingleObject
      };

      this.variants = new slate.Variants(options);

      this.$container.on('variantChange' + this.settings.namespace, this._updateAddToCart.bind(this));
      this.$container.on('variantImageChange' + this.settings.namespace, this._updateImages.bind(this));
      this.$container.on('variantImageChange' + this.settings.namespace, this._updateImagesByGemstone.bind(this));
      this.$container.on('galleryImageChange' + this.settings.namespace, this._updateGalleryImages.bind(this));
      this.$container.on('variantPriceChange' + this.settings.namespace, this._updatePrice.bind(this));
      this.$container.on('variantSKUChange' + this.settings.namespace, this._updateSKU.bind(this));
      if (this.variants && this.variants.currentVariant) {
        this._updateSKUDependentData(this.variants.currentVariant.sku);
      }
    },

    _initImageSwitch: function() {
      if (!$(this.selectors.productThumbImages).length) {
        return;
      }

      var self = this;

      $(document).on('click', this.selectors.productThumbImages, function(evt) {
        evt.preventDefault();
        var $el = $(this);
        var imageSrc = $el.attr('href');
        var zoomSrc = $el.data('zoom');

        self._switchImage(imageSrc, zoomSrc);
        self._setActiveThumbnail(imageSrc);
        $el.parent().addClass('slick-current');
      });
    },

    _setActiveThumbnail: function(src) {
      let gemstoneIndex = this.variants.product.options.indexOf('gemstone');
      if (!(gemstoneIndex > -1)) {
        gemstoneIndex = this.variants.product.options.indexOf('symbol');
      }
      if(jQuery(window).width() >= 768 || gemstoneIndex === -1) {
        var activeClass = 'active-thumb';

        // If there is no element passed, find it by the current product image
        if (typeof src === 'undefined') {
          src = $(this.selectors.productThumbImages + '.activeSlide').attr('href');
        }

        var $thumbnail = $(this.selectors.productThumbImages + '[href="' + src + '"]');

        // Set active thumbnails (incl. slick cloned thumbs) with matching 'href'
        $(this.selectors.productThumbImages).removeClass(activeClass);
        $thumbnail.addClass(activeClass);
        let gemstoneIndex = this.variants.product.options.indexOf('gemstone');
        if (!(gemstoneIndex > -1)) {
          gemstoneIndex = this.variants.product.options.indexOf('symbol');
        }
        if(gemstoneIndex === -1) {
          var slideno = $thumbnail.parent().data('slide');
          $('.primgSlider').slickpdp('slickGoTo', slideno);
        }
      }
    },

    _switchImage: function(image, zoomImage) {
      if($(".index-section--featured-product").length){
        var $image = $(this.selectors.productImageWrap + '[data-zoom="' + zoomImage + '"]').data('slide');
        $(this.selectors.productFeaturedImage).attr('src', image);

        // destroy image zooming if enabled
        if (this.settings.zoomEnabled) {
          _destroyZoom($(this.selectors.productImageWrap));
        }

        if (!this.settings.bpSmall && this.settings.zoomEnabled && zoomImage) {
          $(this.selectors.productImageWrap).data('zoom', zoomImage);
          _enableZoom($(this.selectors.productImageWrap));
        }
      }
    },

    _initImageCustomSlider: function(slider = ".primgSlider") {
      $(slider).on('init', function(_event, _slick){
        $(slider).removeClass('loading');
      });

      $(slider).slickpdp({
        //lazyLoad: 'ondemand',
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        rtl: theme.rtl,
        asNavFor: this.selectors.productThumbs,
        fade: true,
        dots: true,
      });
    },

    _initmainimageSlider: function(slider = ".primgSlider") {
      let gemstoneIndex = this.variants.product.options.indexOf('gemstone');
      if (!(gemstoneIndex > -1)) {
        gemstoneIndex = this.variants.product.options.indexOf('symbol');
      }
      if(gemstoneIndex < 0) {
        let singleVideoSlide = $(slider).find(".video-slide-base");
        let singleSlides = $(slider).find(".product-single__photo");
        if(singleVideoSlide.length){
          if(singleSlides.length>2){
            $(slider).find(".product-single__photo:nth-child(2)").after(singleVideoSlide.first());
          }
        }
      }

      $(slider).on('init', function(_event, _slick){
        $(slider).removeClass('loading');
      });
      if((this.variants.product.options.indexOf('gemstone') > -1) || (this.variants.product.options.indexOf('symbol') > -1)) {
        $(slider).slickpdp({
          //lazyLoad: 'ondemand',
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          rtl: theme.rtl,
          fade: true,
          asNavFor: this.selectors.productThumbs
        });
      } else {
        // TODO: this is where gallery is initalized
        $(slider).slickpdp({
          //lazyLoad: 'ondemand',
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          rtl: theme.rtl,
          fade: true,
          asNavFor: this.selectors.productThumbs,
          responsive: [{
              breakpoint: 767,
              settings: {
                dots: true
              }
            },
          ]
        });
      }
    },

    _initThumbnailSlider: function() {
      /// SLICK VERTICAL TO HORIZONTAL
      let sliderpos = $(this.selectors.productThumbs).attr('data-slider');
      let verticle = true;
      let thumbcount = 5;
      if (sliderpos == 'bottom') {
        verticle = false;
        // thumbcount = 6;
      }

      // console.log("testing slick prev attach: ", $('.primgSlider').find('.slick-prev'));
      var options = {
        verticalSwiping: false,
        swipe: false,
        vertical: verticle,
        slidesToShow: thumbcount,
        slidesToScroll: 1,
        infinite: false,
        rtl: theme.rtl,
        asNavFor: '.primgSlider',
        focusOnSelect: true,
        // appendArrows: '.primgSlider',
        // prevArrow: $('.primgSlider').find('.slick-prev'),
        // nextArrow: $('.primgSlider').find('.slick-next')
      };
      const self = this;
      let gemstoneIndex = this.variants.product.options.indexOf('gemstone');
      if (!(gemstoneIndex > -1)) {
        gemstoneIndex = this.variants.product.options.indexOf('symbol');
      }
      if(gemstoneIndex < 0) {
        let thumbVideoSlide = $(this.selectors.productThumbs).find(".vimeo-thumbnail");
        let thumbsSlides = $(this.selectors.productThumbs).find(".grid__item");
        if(thumbVideoSlide.length){
          if(thumbsSlides.length>2){
            $(this.selectors.productThumbs).find(".grid__item:nth-child(2)").after(thumbVideoSlide.first());
          }
        }
      }
      $(self.selectors.productThumbs).on('init', function(_event, _slick){
        $(self.selectors.productThumbs).removeClass('loading');
      });
      $(this.selectors.productThumbs).slickpdp(options);
      this.settings.sliderActive = true;
    },

    _destroyThumbnailSlider: function() {
      $(this.selectors.productThumbs).slickpdp('unslick');
      this.settings.sliderActive = false;
    },


    _initURLCopy: function() {
      var copyShareButton = $('.social-sharing .share-url'),
      copyLinkContainer = $('#copy-url-container'),
      copyButton = copyLinkContainer.find('.btn-copy'),
      copyText = copyButton.html(),
      shareLink;

      if (copyShareButton.length > 0) {
        shareLink = window.location.href;
        copyLinkContainer.find('#url-text').val(shareLink);

        $('.swatch-element input').on('change', function () {
          shareLink = window.location.href;
          copyLinkContainer.find('#url-text').val(shareLink);
        });

        copyShareButton.on('click', function (e) {
          shareLink = window.location.href;

          e.preventDefault();
          copyLinkContainer.toggleClass('container-visible');
        });

        copyButton.on('click', function () {
          $('#url-text').select();
          document.execCommand("copy");
          copyButton.html('copied');

          setTimeout(function(){
            copyButton.html(copyText);
          }, 2000);
        })

      }
    },
    //PDP add to cart
    _updateAddToCart: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(this.selectors.productPrices).removeClass('visibility-hidden').attr('aria-hidden', 'true');

        // If the variant doesn't exist, disable submit button and change the text.
        // This may be an error or notice that a specific variant is not available.
        // We do the same for the stickyCart button on mobile as well.
        const stickyCartBtn = $(".stickyCart").find(".product-form__cart-submit");

        if (variant.available) {
          $(this.selectors.addToCart).prop('disabled', false);
          $(this.selectors.addToCartText).text(theme.strings.addToCart);

          stickyCartBtn.prop('disabled', false);
          stickyCartBtn.text(theme.strings.addToCart);

          $(".instock").removeClass("hide");
          $(".outstock").addClass("hide");
          var quantity = $("#pvr-"+variant.id).text();
          // $("#quantity_message").show().find(".items").text(quantity);
        } else {
          $(this.selectors.addToCart).prop('disabled', true);
          $(this.selectors.addToCartText).text(theme.strings.soldOut);

          stickyCartBtn.prop('disabled', true);
          stickyCartBtn.text(theme.strings.soldOut);

          $(".instock").addClass("hide");
          $(".outstock").removeClass("hide");
          $("#quantity_message").hide();
        }
      } else {
        $(this.selectors.addToCart).prop('disabled', true);
        $(this.selectors.addToCartText).text(theme.strings.unavailable);
        $(this.selectors.productPrices).addClass('visibility-hidden').attr('aria-hidden', 'false');
        $(".instock").addClass("hide");
        $(".outstock").removeClass("hide");
        $("#quantity_message").hide();
      }
    },
    _updateGalleryImages: function(evt) {
      var variant = evt.variant;
      var self = this;
      //find alt images for the current option
      let currentOptionValue = variant.option1;
      let galleryExtraItems = $('.prod-large-img .gallery-extra img');
      let toRender = [];
      if (galleryExtraItems.length == 0) {
        return;
      }
      galleryExtraItems.each(function( index ) {
        let item = this;
        let alt = $(item).attr('alt');
        let src = $(item).attr('data-src');
        let data = alt.split('|');
        if (data[1] == currentOptionValue) {
          let approvedItem = {
            'slide' : data[0],
            'src' : src,
            'alt' : alt
          };
          toRender.push(approvedItem);
        }
      });
      toRender.forEach(function (element) {
        let slideNumber = element.slide;
        let newImage = element;
        let newImageData = self._getImgSrcData(newImage.src, true);
        let currentImg = $(".primgSlider div[data-slick-index='" + slideNumber + "'] img.product-featured-img").first();
        let currentSrc = $(currentImg).attr('src');
        let srcData = self._getImgSrcData(currentSrc);
        if (srcData) {
          let toUpdate = $(".product-single__photos img[data-src*='" + srcData.filenamePrefix + "']");
          toUpdate.each(function( _index ) {
            let item = this;
            if(!$(item).parent().hasClass('gallery-extra')) {
              const curSrc = $(item).attr('src');
              const curDataSrc = $(item).attr('data-src');
              const curSrcData = self._getImgSrcData(curSrc);
              const curDataSrcData = self._getImgSrcData(curDataSrc);
              //use old size + new path
              let sizeStr = '';
              if (!curDataSrcData.isFullsize) {
                sizeStr = '_' + curDataSrcData.size;
              }
              let newSrc = newImageData.hrefPrefix + newImageData.filenamePrefix + sizeStr + '.'
                + newImageData.ext + newImageData.query;
              if (curDataSrcData) {
                $(item).attr('data-src', newSrc);
              }
              if (curSrcData && curSrcData.filenamePrefix != 'spacer_') {
                $(item).attr('src', newSrc);
              }
            }
          });
        }
      })
    },
    _getImgSrcData: function(src, isFullsize = false) {
      let result = false;
      let toReturn = {};
      let url = false;
      try {
        url = new URL('https:' + src);
      } catch (error) {
        console.error(error);
      }
      if (url) {
        toReturn.query = url.search;
        const filename = url.pathname.split('/').pop();
        const ext = filename.split('.').pop();
        let fileData = filename.split('_');
        let size = fileData.pop().split('.').shift();

        toReturn.filename = filename;
        toReturn.ext = ext;
        toReturn.size = size;
        toReturn.filenamePrefix = fileData.join('_');
        const sizeParts = size.split('x');
        let checkFullSize = true;
        sizeParts.forEach(function (element) {
          if(isNaN(element) || element.length == 0) {
            checkFullSize = checkFullSize && true;
          } else {
            checkFullSize = checkFullSize && false;
          }
        });
        if (checkFullSize) {
          isFullsize = true;
        }

        if (isFullsize) {
          toReturn.filenamePrefix = toReturn.filenamePrefix + '_' + size;
        }
        toReturn.hrefPrefix = url.href.split(filename).shift();
        toReturn.isFullsize = isFullsize;
        result = toReturn;
      }
      return result;
    },
    _getImgSrcPrefix: function(src) {
      let result = false;
      let data = src.split('/').slice(-1);
      return result;
    },
    _updateImages: function(evt) {
      var variant = evt.variant;

      var sizedImgUrl = theme.Images.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);
      var zoomSizedImgUrl;

      if (this.settings.zoomEnabled) {
        zoomSizedImgUrl = theme.Images.getSizedImageUrl(variant.featured_image.src, this.settings.imageZoomSize);
      }

      this._switchImage(sizedImgUrl, zoomSizedImgUrl);

      this._setActiveThumbnail(sizedImgUrl);

    },
    _setFakeTrackPosition: function(track, translateValue) {
      $(track).css({
        WebkitTransition : `translate3d(0, ${translateValue}px, 0)`,
        MozTransition    : `translate3d(0, ${translateValue}px, 0)`,
        MsTransition     : `translate3d(0, ${translateValue}px, 0)`,
        OTransition      : `translate3d(0, ${translateValue}px, 0)`,
        transform  : `translate3d(0, ${translateValue}px, 0)`
      });
    },
    _refreshFakeSlickEvent: function(trackWrap, count){
      const _self = this,
      sliderHeight = jQuery(trackWrap).find('.slick-slide').first().outerHeight();

      let slidesNum = jQuery(trackWrap).find('.slick-slide').length;
      slidesNum = slidesNum < count ? slidesNum : count;
      jQuery(trackWrap).css({height: sliderHeight * slidesNum});
    },
    _fakeSlickEvent: function(trackWrap, count) {
      const _self = this,
      slides = jQuery(trackWrap).find('.fake-slick-track')[0],
      sliderHeight = jQuery(trackWrap).find('.slick-slide').first().outerHeight(),
      sliderWrapHeight = sliderHeight * count,
      bottomExtremePoint = sliderWrapHeight - jQuery(slides).find('.grid__item').length * sliderHeight,
      currentTrackID = jQuery(trackWrap).attr('id');
      let slidesNum = jQuery(trackWrap).find('.slick-slide').length;
      slidesNum = slidesNum < count ? slidesNum : count;
      jQuery(trackWrap).css({
        height: sliderHeight * slidesNum
      });
      // const endOfSlideEvent = function(currentTrackWrap) {
      //   let position = Math.round(jQuery(slides).position().top / sliderHeight) * sliderHeight;
      //   if(position > 0) position = 0;
      //   if(position < bottomExtremePoint) position = bottomExtremePoint;
      //   _self._setFakeTrackPosition(slides, position);
      //   sliderPosition =  jQuery(slides).offset().top - trackWrapTop;
      //   previousPoint =  0;
      // };

      // const moveSlide = function(e) {
      //   const pageY = e.type === 'touchmove' ? e.originalEvent.touches[0].pageY : e.pageY;
      //   let slidesTop = $(slides).offset().top,
      //       slidesBottom = slidesTop + $(slides).outerHeight();
      //   if(previousPoint === 0) {
      //     previousPoint = pageY;
      //   } else {
      //     const direction = pageY - previousPoint;
      //     if(!((direction > 0 && slidesTop >= trackWrapTop) || (direction < 0 && slidesBottom <= trackWrapBottom))) {
      //       _self._setFakeTrackPosition(slides, sliderPosition + direction);
      //     }
      //   }
      // };
      // $(trackWrap).on('mousedown touchstart', function(e){
      //   $(this).one('mouseup touchend', function(e){
      //     $(this).off('mousemove');
      //     $(this).off('touchmove');
      //     endOfSlideEvent(this);
      //   }).on('mousemove', function(e){
      //     e.preventDefault();
      //     moveSlide(e);
      //   }).on('touchmove', function(e){
      //     if (e.cancelable) {
      //       e.preventDefault();
      //       e.stopPropagation();
      //     }
      //     e.preventDefault();
      //      moveSlide(e);
      //   });
      //   $(this).one('mouseleave', function (e) {
      //     e.preventDefault();
      //     $(this).off('mousemove');
      //     endOfSlideEvent(this);
      //   })
      //
      // });

      const changeSlide = function(dir) {
        let previousPoint = 0,
        sliderPosition = 0,
        trackWrapTop = jQuery(trackWrap).offset().top,
        trackWrapBottom = trackWrapTop + jQuery(trackWrap).outerHeight();
        let position = Math.round(jQuery(slides).position().top / sliderHeight) * sliderHeight;
        let slidesTop = $(slides).offset().top,
        slidesBottom = slidesTop + $(slides).outerHeight();
        let targetSlide = false;
        let currentSlide = jQuery(slides).find('.slick-current');
        if (currentSlide.length == 0) {
          currentSlide = jQuery(slides).find('.video-thumbnail');
        }
        let prevSlide = currentSlide.prev();
        let nextSlide = currentSlide.next();

        if (dir === 'next' && nextSlide.length) {
          targetSlide = nextSlide;
        }
        if (dir === 'prev' && prevSlide.length) {
          targetSlide = prevSlide;
        }

        if(dir === 'next' && slidesBottom > trackWrapBottom) {
          _self._setFakeTrackPosition(slides, position - sliderHeight);
          $('.fake-slick-prev').removeAttr('disabled');

          if (slidesBottom - sliderHeight <= trackWrapBottom) {
            //$('.fake-slick-next').attr('disabled' , 'disabled')
          } else {
            $('.fake-slick-next').removeClass('inactive');
          }
        }

        if (dir === 'prev' && (slidesTop + sliderHeight) <= trackWrapTop){
          _self._setFakeTrackPosition(slides, position + sliderHeight);
          $('.fake-slick-next').removeAttr('disabled');

          if ((slidesTop + sliderHeight) >= trackWrapTop) {
            //$('.fake-slick-prev').attr('disabled' , 'disabled');
          } else {
            $('.fake-slick-prev').removeClass('inactive');
          }
        }
        if (targetSlide) {
          //let realPosition = targetSlide.attr('data-slick-index');
          //jQuery('.primgSlider').slickpdp('slickGoTo', realPosition);
          currentSlide.removeClass('slick-current');
          targetSlide.find('a').click();
          targetSlide.click();
        }
      };

      $('.arrow-' + currentTrackID).on('click', function (e){
        e.preventDefault();
        if($(this).hasClass('fake-slick-next')){
          changeSlide("next");
        } else {
          changeSlide("prev");
        }
      })
    },

    _initImagesByGemstone: function(variant) {
      const self = this;
      const isGemstoneIndex = (this.variants.product.options.indexOf('gemstone') > -1) || (this.variants.product.options.indexOf('symbol') > -1) ? true : false;
      if(isGemstoneIndex) {
        enquire.register(this.settings.mediaQuerySmall, {
          match: function() {
            const windowDelay = window.setTimeout(function() {
              jQuery('.grid__item.prod-thumbs').hide();
              self._updateImagesByGemstone();
            }, 100);
          },
          unmatch: function() {
            jQuery(".primgSlider").show();
            jQuery(".primgSlider.primgSlider-custom").hide();
            jQuery('.grid__item.prod-thumbs').show();
            const windowDelay = window.setTimeout(function() {
              jQuery(".primgSlider").slickpdp('refresh');
              self._updateImagesByGemstone();
            }, 100);
          }
        });
        this._updateImagesByGemstone(variant);
      }
    },

    _updateImagesByGemstone: function(evt = {variant: this.variants.currentVariant}) {
      let gemstoneIndex = this.variants.product.options.indexOf('gemstone');
      if (!(gemstoneIndex > -1)) {
        gemstoneIndex = this.variants.product.options.indexOf('symbol');
      }
      if(gemstoneIndex > -1) {
        const variant = typeof evt !== 'undefined' ? evt.variant : this.variants.currentVariant;
        const trackClassName = variant.options[gemstoneIndex].trim().toLowerCase().replace(/\s/g, '-');
        const possibleVariants = jQuery('.swatch-container').find(`[value*="${variant.options[gemstoneIndex]}"]`);
        if(jQuery(window).width() >= 768) {
          const currentTrackByColor = jQuery(`#fake-slick__${trackClassName}`);
          jQuery('.fake-slick-arrow').hide();
          if (currentTrackByColor && currentTrackByColor.length > 0) {
            let currentThumb = currentTrackByColor.find('.product-single__thumbnails-item').first();
            jQuery('.slick-vertical .slick-list').hide();
            jQuery('.slick-vertical .slick-arrow').hide();
            jQuery('.slick-vertical .fake-slick-list').find('.slick-track').css('transform', 'translate3d(0px, 0px, 0px)');
            currentTrackByColor.show();
            currentTrackByColor.prev('.fake-slick-prev').addClass('inactive');
            currentTrackByColor.prev('.fake-slick-prev').show();
            //currentTrackByColor.next('.fake-slick-next').show().removeAttr('disabled');
            currentTrackByColor.next('.fake-slick-next').show();
            currentThumb.addClass('slick-current');
            const windowDelay = window.setTimeout(() => {
              $('.primgSlider').slickpdp('slickGoTo', currentThumb.data('slide'));
            }, 50);
            this._refreshFakeSlickEvent(currentTrackByColor, 5)
          } else {
            let visibleImages = jQuery(`.slick-list:not(.fake-slick-list) .grid__item .product-single__thumbnail-image[data-gemstone*="${variant.options[gemstoneIndex]}"`).closest('.grid__item').removeAttr('style');
            if(possibleVariants.length > 1) {
              jQuery(possibleVariants).map((index, item) => {
                if(jQuery(item).val() !== variant.options[gemstoneIndex]) {
                  const a = jQuery(visibleImages).find(`.product-single__thumbnail-image[data-gemstone*="${jQuery(item).val()}"]`).closest('.grid__item');
                  visibleImages = jQuery(visibleImages).not(a);
                }
              });
            }
            const video = jQuery('.thumbnails-wrapper .slick-list:not(.fake-slick-list) .vimeo-thumbnail').clone().removeAttr('style');
            if(typeof visibleImages !== 'undefined' && visibleImages.length > 0) {
              let itemsCount = visibleImages.length;
              var activeImage = jQuery(visibleImages).first().data('slide');
              var fakeSlickTrack = jQuery(`<div class="fake-slick-track slick-track"></div>`).append(visibleImages);
              if(typeof video !== 'undefined' && video.length > 0) {
                if(itemsCount > 2){
                  jQuery(fakeSlickTrack).find(".grid__item:nth-child(2)").after(video);
                } else {
                  jQuery(fakeSlickTrack).append(video);
                }
                jQuery(video).on('click', function (){
                  jQuery('.primgSlider').slickpdp('slickGoTo', jQuery(this).data('slick-index'));
                });

                let currentMaintThumb = jQuery(visibleImages).first().find('img').data('src');
                jQuery(fakeSlickTrack).find('.vimeo-thumbnail img').attr("data-src", currentMaintThumb);
                itemsCount++;
              }
              let altVideo = jQuery('.thumbnails-wrapper .slick-list:not(.fake-slick-list) .video-thumbnail-alt').clone().removeAttr('style');
              if(typeof altVideo !== 'undefined' && altVideo.length > 0) {
                jQuery(fakeSlickTrack).append(altVideo);

                jQuery(altVideo).on('click', function (){
                  jQuery('.primgSlider').slickpdp('slickGoTo', jQuery(this).data('slick-index'));
                });
              }
              const newSlickTrack = jQuery(`<div id="fake-slick__${trackClassName}" aria-live="polite" class="slick-list fake-slick-list ${visibleImages.length > 5 ? 'loading' : ''}"></div>`).append(fakeSlickTrack);
              const newButton = jQuery(`<button type="button" data-role="none" class="fake-slick-arrow arrow-fake-slick__${trackClassName}" role="button"></button>`);
              let nextButton = jQuery(newButton).clone().html('Next').addClass('fake-slick-next').attr('aria-label', 'Next');
              let prevButton = jQuery(newButton).clone().html('Previous').addClass('fake-slick-prev inactive').attr('aria-label', 'Previous');
              jQuery('.slick-vertical .slick-list').hide();
              jQuery('.slick-vertical .slick-arrow').hide();
              jQuery('.thumbnails-wrapper > .product-single__thumbnails').append(newSlickTrack);
              jQuery(newSlickTrack).find('.product-single__thumbnails-item').first().addClass('slick-current');

              var i = 0;
              var n = jQuery(newSlickTrack).find('.slick-slide').length;
              jQuery(newSlickTrack).find('.slick-slide').each(function() {
                i += 1;
                if (i == 1) {
                  jQuery(this).on('click', function (e) {
                    prevButton.addClass('inactive');
                    nextButton.removeClass('inactive');
                  })
                } else if (i == n) {
                  jQuery(this).on('click', function (e) {
                    prevButton.removeClass('inactive');
                    nextButton.addClass('inactive');
                  })
                } else {
                  jQuery(this).on('click', function (e) {
                    prevButton.removeClass('inactive');
                    nextButton.removeClass('inactive');
                  })
                }
              });
              jQuery(newSlickTrack).find('.slick-slide').first().on('click', function (e) {
                prevButton.addClass('inactive');
              })
              jQuery(newSlickTrack).find('.slick-slide').last().on('click', function (e) {
                nextButton.addClass('inactive');
              })
              if (true) {
                jQuery('.fake-slick-arrow').hide();
                jQuery(newSlickTrack).after(nextButton).before(prevButton);
                const windowDelay = window.setTimeout(() => {
                  this._fakeSlickEvent(newSlickTrack, 5);
                  jQuery(newSlickTrack).removeClass('loading');
                }, 100);
              }
              const windowDelay = window.setTimeout(() => {
                $('.primgSlider').slickpdp('slickGoTo', activeImage);
              }, 50);
            }
          }
        } else {
          const currentTrackByColor = jQuery(`#fake-primgSlider__${trackClassName}`);
          if (currentTrackByColor && currentTrackByColor.length > 0) {
            jQuery(".primgSlider").hide();
            currentTrackByColor.show();
            const windowDelay = window.setTimeout(() => {
              jQuery(`#fake-primgSlider__${trackClassName}`).slickpdp('refresh');
            }, 100);
          } else {
            let visibleMobileImages = jQuery(`.primgSlider:not(.primgSlider-custom) .product-featured-img[data-gemstone*="${variant.options[0]}"]`).closest('.product-single__photo').removeAttr('style');
            if(possibleVariants.length > 1) {
              jQuery(possibleVariants).map((index, item) => {
                if(jQuery(item).val() !== variant.options[gemstoneIndex]) {
                  const a = jQuery(visibleMobileImages).find(`.product-featured-img[data-gemstone*="${jQuery(item).val()}"]`).closest('.product-single__photo');
                  visibleMobileImages = jQuery(visibleMobileImages).not(a);
                }
              });
            }
            const video = jQuery(`.primgSlider:not(.primgSlider-custom) .video-slide-base`).clone().removeAttr('style');
            let newMobileSlickTrack = jQuery(`<div id="fake-primgSlider__${trackClassName}" class="primgSlider primgSlider-custom"></div>`).append(visibleMobileImages);
            if(typeof video !== 'undefined' && video.length > 0) {
              if(visibleMobileImages.length > 2){
                jQuery(newMobileSlickTrack).find(".product-single__photo:nth-child(2)").after(video);
              } else {
                jQuery(newMobileSlickTrack).append(video);
              }
            }
            let altVideo = jQuery(`.primgSlider:not(.primgSlider-custom) .video-slide-alt`).clone().removeAttr('style');
            if(typeof altVideo !== 'undefined' && altVideo.length > 0) {
              jQuery(newMobileSlickTrack).append(altVideo);
            }
            jQuery(".primgSlider").hide();
            jQuery('.grid__item.prod-large-img').prepend(newMobileSlickTrack);
            const windowDelay = window.setTimeout(() => {
              this._initImageCustomSlider(`#fake-primgSlider__${trackClassName}`);
            }, 100);
          }
        }
      }
    },

    _updatePrice: function(evt) {
      var variant = evt.variant;

      // Update the product price
      $(this.selectors.originalPrice).html(theme.Currency.formatMoney(variant.price, theme.moneyFormat).replace(/((\,00)|(\.00))$/g, ''));

      // Update and show the product's compare price if necessary
      if (variant.compare_at_price > variant.price) {
        $(this.selectors.comparePrice).html(theme.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat)).removeClass('hide');
        $(this.selectors.originalPriceWrapper).addClass(this.selectors.saleClasses);
        $(this.selectors.saleLabel).removeClass('hide');
        var price1 = variant.compare_at_price-variant.price,
        price2 = price1 * 100
        salecount = price2/variant.compare_at_price;
        $(this.selectors.discountBadge).find('.off').find('span').text(+salecount.toFixed());
        $(this.selectors.discountBadge).removeClass('hide');
        $(this.selectors.saveAmount).html(theme.Currency.formatMoney(price1,  theme.moneyFormat));

      } else {
        $(this.selectors.comparePrice).addClass('hide');
        $(this.selectors.saleLabel).addClass('hide');
        $(this.selectors.discountBadge).addClass('hide');
        $(this.selectors.originalPriceWrapper).removeClass(this.selectors.saleClasses);
      }
    },

    _updateSKU: function(evt) {
      var variant = evt.variant;

      // Update the sku
      $(this.selectors.SKU).html(variant.sku);
      this._updateSKUDependentData(variant.sku);
    },

    _updateSKUDependentData: function(sku) {
      var styleText = 'Style #: ' + sku;
      var styleContent = '<li class="sku">' + 'Style #: ' + sku + '</li>';
      if($('.product-description ul:first li:last').hasClass('sku')) {
        $('.product-description ul:first li:last').html(styleText);
      } else {
        $('.product-description ul:first').append(styleContent);
      }
      //$('#ContactProductPdp').val(styleText);
      $('#ContactFormMessagePdp').text(styleText + '\n');
    },

    _initGropedProductPopup: function() {
      var self = this;

      $(document).on('click', '.grouped-images-popup-opener', function(evt) {
        evt.preventDefault();
        var opener = $(this),
        popup = opener.closest('.group-prod-item').find('.gallery-items-popup');

        if($('html').hasClass('grouped-popup-active')) {
          $('html').removeClass('grouped-popup-active');
          popup.removeClass('current-popup-active');
        } else {
          $('html').addClass('grouped-popup-active');
          popup.addClass('current-popup-active');
        }
      });

      $(document).on('click', '.gallery-items-popup-close', function(evt) {
        evt.preventDefault();
        var popup = $(this).closest('.gallery-items-popup');

        $('html').removeClass('grouped-popup-active');
        popup.removeClass('current-popup-active');
      });

      $('.gallery-items-main-image').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        infinite: false,
        fade: true,
        asNavFor: '.gallery-items-thumbnails'
      });
      $('.gallery-items-thumbnails').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: '.gallery-items-main-image',
        focusOnSelect: true,
        infinite: false,
        dots: false,
        swipe: false,
        vertical: true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              vertical: false
            }
          }
        ]
      });
    },

    onUnload: function() {
      this.$container.off(this.settings.namespace);
    }
  });

  function _enableZoom($el) {
    var zoomUrl = $el.data('zoom');
    $el.zoom({
      url: zoomUrl
    });
  }

  function _destroyZoom($el) {
    $el.trigger('zoom.destroy');
  }

    $("body").click(function(){
        var reviewMessage = $(".products-review-section .spr-form-message");
        if (reviewMessage.length > 0){
            reviewMessage.hide()
        }
    });

  return Product;
})();

// Product quick view
theme.QuickView = (function() {
  $( 'body' ).on( 'click', '.quick-view', function(e) {
    e.preventDefault(); e.stopPropagation();
    $.ajax({
      beforeSend : function (){
        $('body').addClass("loading");
       },
      url: $(this).attr('href'),
      success: function(data) {
        $.magnificPopup.open({
          items: {
            src: '<div class="quick-view-popup" id="content_quickview">' + data + '</div>',
            type: 'inline'
          },
          removalDelay:500,
          callbacks: {
            beforeOpen: function() {
              this.st.mainClass = 'mfp-move-horizontal';
            },
            close: function() {
              $( '#content_quickview' ).empty();
            }
          },
        });
      },
      complete: function() {
        $('body').removeClass("loading");
      }
    })
  });
})();

theme.Quotes = (function() {
  var config = {
    mediaQuerySmall: 'screen and (max-width: 749px)',
    mediaQueryMediumUp: 'screen and (min-width: 750px)',
    slideCount: 0
  };
  var defaults = {
    accessibility: true,
    arrows: true,
    dots: false,
    autoplay: false,
    rtl: theme.rtl,
    touchThreshold: 20,
    slidesToShow: 1,
    slidesToScroll: 1
  };

  function Quotes(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var wrapper = this.wrapper = '.quotes-wrapper';
    var slider = this.slider = '#Quotes-' + sectionId;
    var $slider = $(slider, wrapper);

    var sliderActive = false;
    var mobileOptions = $.extend({}, defaults, {
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true
    });

    config.slideCount = $slider.data('count');

    // Override slidesToShow/Scroll if there are not enough blocks
    if (config.slideCount < defaults.slidesToShow) {
      defaults.slidesToShow = config.slideCount;
      defaults.slidesToScroll = config.slideCount;
    }

    $slider.on('init', this.a11y.bind(this));

    enquire.register(config.mediaQuerySmall, {
      match: function() {
        initSlider($slider, mobileOptions);
      }
    });

    enquire.register(config.mediaQueryMediumUp, {
      match: function() {
        initSlider($slider, defaults);
      }
    });

    function initSlider(sliderObj, args) {
      if (sliderActive) {
        sliderObj.slick('unslick');
        sliderActive = false;
      }

      sliderObj.slick(args);
      sliderActive = true;
    }
  }

  Quotes.prototype = _.assignIn({}, Quotes.prototype, {
    onUnload: function() {
      enquire.unregister(config.mediaQuerySmall);
      enquire.unregister(config.mediaQueryMediumUp);

      $(this.slider, this.wrapper).slick('unslick');
    },

    onBlockSelect: function(evt) {
      // Ignore the cloned version
      var $slide = $('.quotes-slide--' + evt.detail.blockId + ':not(.slick-cloned)');
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      $(this.slider, this.wrapper).slick('slickGoTo', slideIndex);
    },

    a11y: function(event, obj) {
      var $list = obj.$list;
      var $wrapper = $(this.wrapper, this.$container);

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    }
  });

  return Quotes;
})();

theme.slideshows = {};

theme.SlideshowSection = (function() {
  function SlideshowSection(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var slideshow = this.slideshow = '#Slideshow-' + sectionId;

    $('.slideshow__video', slideshow).each(function() {
      var $el = $(this);
      theme.SlideshowVideo.init($el);
      theme.SlideshowVideo.loadVideo($el.attr('id'));
    });

    theme.slideshows[slideshow] = new theme.Slideshow(slideshow);
  }

  return SlideshowSection;
})();

theme.SlideshowSection.prototype = _.assignIn({}, theme.SlideshowSection.prototype, {
  onUnload: function() {
    delete theme.slideshows[this.slideshow];
  },

  onBlockSelect: function(evt) {
    var $slideshow = $(this.slideshow);

    // Ignore the cloned version
    var $slide = $('.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)');
    var slideIndex = $slide.data('slick-index');

    // Go to selected slide, pause autoplay
    $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
  },

  onBlockDeselect: function() {
    // Resume autoplay
    $(this.slideshow).slick('slickPlay');
  }
});

// CATEGORY SLIDER
theme.collectionView = (function() {
  function collectionView(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var sliderSecond = $container.attr('data-section-timeout');

    ajaxfilter = (function(url){

        var urlparam = getSearchParams(),
          urlparam = $.param( urlparam );

        if(urlparam){
          var splite_url = url.split('?');
          url = splite_url.join('?');
          //url = splite_url[0];
        }

        $.ajax({
          type: 'GET',
          url: url,
          data: {},
          beforeSend:function(){
            $('body').addClass('loading hideOverly');
          },
          complete: function(data) {

            $('.productList .grid-products').html($(".productList .grid-products", data.responseText).html());
            $('.productList .grid-products').html($(".productList .grid-products", data.responseText).html());
            $('.filters-toolbar__product-count').html($(".filters-toolbar__product-count", data.responseText).html());

            $('.sidebar_tags').html($(".sidebar_tags", data.responseText).html());
            check_filters();

            $('.pagination').html($(".pagination", data.responseText).html());
            if(!$(".pagination", data.responseText).html()){
              $('.pagination').hide();
            } else {
              $('.pagination').show();
            }
            $('.infinitpaginOuter').html($(".infinitpaginOuter", data.responseText).html());
            if(!$(".infinitpaginOuter", data.responseText).html()){
              $('.infinitpagin').remove();
            }
            if(theme.mlcurrency){
              Currency.convertAll(shopCurrency, $('#currencies li.selected').attr('data-currency'));
            }
            $('body').removeClass('loading hideOverly');
            $(theme.colorSwatches); $(theme.ajaxCart); loadMoreBtn();

            if($(".spr-badge").length > 0) {
            	$.getScript(window.location.protocol + "//productreviews.shopifycdn.com/assets/v4/spr.js");
            }
            productGridView(sectionId);
            setTimeout(function(){ productGridView(sectionId); },1000);

            history.pushState({
              page: url
            }, url, url);
          }
        });
    });
    function getSearchParams(k){
      var p={};
      location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi,function(s,k,v){p[k]=v})
      return k?p[k]:p;
    }

	$(window).on('load delayed-resize', function (e, resizeEvent) {
  		productGridView(sectionId);
    });

    infiniteScroll = function(){
        $(window).on('scroll load delayed-resize', function(){
          var moreURL = $('.infinitpagin a').attr('href');
          if ($('.infinitpagin a.infinite').length){
            var bottom = $('.infinitpagin').offset();
            var docTop = ($(document).scrollTop() + $(window).height() - 50);
            if( docTop > bottom.top){
              $(window).off('scroll load delayed-resize');
              loadMore(moreURL);
            }
          }
        });
    }
    loadMoreBtn = function() {
		$('.infinitpagin a.loadMore').click(function(e){
          	e.preventDefault();
          	var moreURL = $(this).attr('href');
			loadMore(moreURL);
        });
    }

    loadMore = function(moreURL) {
      if (moreURL.length){
        $.ajax({
          type: 'GET',
          dataType: 'html',
          url: moreURL,
          beforeSend:function(){
          	if ($('.infinitpaginOuter').attr('data-type') == "button" ){
            	$('body').addClass('loading hideOverly');
            } else {
              $('.infinitpagin a').show();
            }
          },
          complete: function (data) {
            if($('.productList .grid-products').length){
            	$('.productList .grid-products').append($(".productList .grid-products", data.responseText).html());
            } else {
              	$('.productList .list-view-items').append($(".productList .list-view-items", data.responseText).html());
            }
            if($(".infinitpagin", data.responseText).html()){
            	$('.infinitpagin').html($(".infinitpagin", data.responseText).html());
            } else {
            	$('.infinitpagin').remove();
            }
            if(theme.mlcurrency){
              Currency.convertAll(shopCurrency, $('#currencies li.selected').attr('data-currency'));
            }
            $(theme.ajaxCart); $(theme.colorSwatches); productGridView(sectionId);
			if($(".spr-badge").length > 0) {
                  $.getScript(window.location.protocol + "//productreviews.shopifycdn.com/assets/v4/spr.js");
            }
            setTimeout(function(){ productGridView(sectionId); },1000);
            if ($('.infinitpagin a.loadMore').length){ loadMoreBtn(); } else { infiniteScroll(); }
            $('body').removeClass('loading hideOverly');
          }
        });
      }
    }

    $(document).ready(function(){ infiniteScroll();loadMoreBtn(); });
  }

  return collectionView;
})();


/// collection tab prodct slider
theme.carouselSection = {};

theme.carouselSection = (function(){
  function carouselSection(container){
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var carousel = $($container).find('.carousel'),
        tabs = this.tabs = '#carousel-' + sectionId + ' .tablink',
    	tabcontent = this.tabcontent = '#carousel-' + sectionId + ' .tab-content';

    $(carousel).slick();

    $(tabs).on('click', function (e) {
        e.preventDefault();
        $(this).parent().addClass("active");
        $(this).parent().siblings().removeClass("active");
        var tab = $(this).attr("href");
        $(tabcontent).not(tab).css("display", "none");
        $(tab).fadeIn();
      	$(carousel).slick('refresh');
    });
    $('#carousel-' + sectionId).each(function(){
		$(this).find('.collection-tabs li:first-child').addClass("active");
		$(this).find('.tab-container h3:first-child + .tab-content').show();
		var firsttab = $(this).find('.collection-tabs li:first-child a').attr("href");
      	$(carousel).slick('refresh');
    });

    $(window).on('load delayed-resize', function (e, resizeEvent) {
  		productGridView('carousel-' + sectionId);
    });
  }

  return carouselSection;
})();

theme.masonary = (function(){
    function masonary(container){
    	var $container = this.$container = $(container),
          sectionId = $container.attr('data-section-id'),
          masonary = this.masonary = $($container).find('.grid-masonary');

      loadMasonary(masonary);
      setTimeout( function(){ loadMasonary(masonary); },1000);
      function loadMasonary(masonary) {
        $(masonary).masonry({
            columnWidth: '.grid-sizer-'+sectionId,
            itemSelector: '.ms-item',
            percentPosition: true
        });
      }
  }
  return masonary;
})();

function productGridView(sectionId) {
  var gridRows = [];
  var tempRow = [];

  productGridElements = $('#'+sectionId+' .grid-products .grid__item');
  productGridElements.each(function (index) {
    if ($(this).css('clear') != 'none' && index != 0) {
      gridRows.push(tempRow);
      tempRow = [];
    }
    tempRow.push(this);

    if (productGridElements.length == index + 1) {
      gridRows.push(tempRow);
    }
  });

  $.each(gridRows, function () {
    var tallestHeight = 0;
    var tallestHeight1 = 0;
    $.each(this, function () {
      $(this).find('.grid-view_image a.grid-view-item__link').css('height', '');

      elHeight = parseInt($(this).find('.grid-view_image').css('height'));

      if (elHeight > tallestHeight) { tallestHeight = elHeight; }
    });

    $.each(this, function () {
      if($(window).width() > 750) {
      	$(this).find('.grid-view_image > a.grid-view-item__link').css('height', tallestHeight);
      }
    });
  });
}

// COLOR SWATCH ON COLLECTION PAGE
theme.colorSwatches = (function() {
  function changeImageByGemstone(gemstone, imageClaass = '.variantImg', showVariant = true) {
    var newImage = $(gemstone).attr('rel');
    $(gemstone).parents('.grid-view-item').find('.grid-view-item__link').addClass("showLoading");
    $(gemstone).parents('.grid-view-item').find(imageClaass).attr({ src: newImage });
    if(!showVariant) {
      const newSrcset =  $(gemstone).data('srcset');
      $(gemstone).parents('.grid-view-item').find(imageClaass).attr({ srcset: newSrcset });
    }
    $(gemstone).parents('.grid-view-item').find(imageClaass).load(function() {
      if(showVariant) $(gemstone).parents('.grid-view-item').find('.grid-view-item__link').addClass("showVariantImg");
      $(gemstone).parents('.grid-view-item').find('.grid-view-item__link').removeClass("showLoading");
    });
  }
  function changePriceByGemstone(gemstone) {
    const newPrice =  $(gemstone).data('price');
    $(gemstone).parents('.grid-view-item').find('.product-price__price').text(newPrice);
  }
  $('.grid-view-item .swatches li:not(.noImg)').hover(function() {
    changeImageByGemstone(this);
    return false;
  }
  ,function() {
    $(this).parents('.grid-view-item').find('.grid-view-item__link').removeClass("showLoading");
    $(this).parents('.grid-view-item').find('.grid-view-item__link').removeClass("showVariantImg");
    return false;
  }
  );
  $('.grid-view-item .swatches li:not(.noImg)').click(function () {
    $(this).closest('.swatches').find('li.swatch').removeClass('active');
    $(this).addClass('active');
    changeImageByGemstone(this, '.primary', false);
    changePriceByGemstone(this);
  })
});
$(theme.colorSwatches);

theme.instagramSection = (function() {
  function instagramSection(container) {
    var $container = this.$container = $(container),
    	sectionId = $container.attr('data-section-id'),
        token = $container.attr('data-token'),
        user = $container.attr('data-user'),
        imagesize = $container.attr('data-image'),
        num_photos = $container.attr('data-count'),
        instagramurl = 'https://api.instagram.com/v1/users/' + user + '/media/recent';

    $.ajax({
        url: instagramurl,
        dataType: 'jsonp',
        type: 'GET',
        data: {access_token: token, count: num_photos},
        success: function(data){
            for( x in data.data ){
	            if(imagesize == "thumbnail"){
                    imageurl = data.data[x].images.thumbnail.url
                } else if(imagesize == "standard_resolution") {
                    imageurl = data.data[x].images.standard_resolution.url
                } else {
                    imageurl = data.data[x].images.low_resolution.url
                }
                $('#instafeed').append('<div class="insta-img"><a href="'+data.data[x].link+'"><img src="'+imageurl+'"></a></div>');
            }
        },
        error: function(data){
            console.error(data); // send the error notifications to console
        }
    });
  }
  return instagramSection;
})();

theme.ajaxCart = function(){
  	var drawerTimeout = null;
    var submitTimeout = true;
  	quickshop(),gridAddToCart(),prodAddToCart();wishlist();updateWishlist();

	$(".continue-shopping, .modalOverly, .closeDrawer").click(function(){
        $(".modal").fadeOut(200);
    	$("body").removeClass("loading showOverly");
    });
  	function quickshop() {
      $(document).on('click', '.quickShop', function(e){
          e.preventDefault(); e.stopImmediatePropagation();
          var url = $(this).attr('href'),
              imgwrapper = $(this).parents(".grid-view-item").find(".grid-view_image"),
              wrapper = $(this).parents(".grid-view-item").find('.shopWrapper');
          $.ajax({
            url: url,
            dataType: 'html',
            type: 'GET',
            beforeSend:function(){
              $(imgwrapper).addClass('showLoading');
            },
            success: function(data) {
              $(".shopWrapper").removeClass('active').html("");
              $(wrapper).addClass('active').html(data);
            },
            complete: function(data){
              $(imgwrapper).removeClass('showLoading');
              if (theme.mlcurrency){ currenciesChange(".shopWrapper.active .product-single__price span.money"); }
              $(".closeShop").click(function(){
                $(this).parents(".shopWrapper").removeClass("active");
              });
            }
          });
      });
    }
  	function gridAddToCart() {
      $(".add-to-cart").click(function(i) {
        i.preventDefault();i.stopImmediatePropagation();
          if (theme.ajax_cart) {
            var att = $(this).attr("id"),
            	qty = $(this).attr("rel");
            addinToCart(att, qty);
          } else {
            $(this).parent().submit();
          }
        return;
      });
    }
    function validateEngraving(props)
    {
      let result = true;
      if ($('#add-engraving-mode') && $('#add-engraving-mode').prop('checked')) {
        if(!props['Custom Engraving']) {
          result = false;
        } else {
          let eVal = props['Custom Engraving'];
          const lastChar = eVal.substring(eVal.length - 1, eVal.length);
          const firstChar = eVal.substring(0, 1);
          if (lastChar == ' ' || firstChar == ' ') {
            result = false;
          }
        }
        const blankError = $('#blankError');
        if (blankError && result) {
          blankError.hide();
        } else {
          blankError.show().text("Engrave the item before adding to bag.");
        }
      } else {
        if(props['Custom Engraving']) {
          delete props['Custom Engraving'];
          delete props['_LPROP'];
        }
      }
      return {'result':result, 'props':props};
    }
    function prodAddToCart(){
      $(".product-form__cart-submit").click(function(i) {
          var giftContainer = $(this).prev("#gsAppContainer");
          if (giftContainer.length > 0) {
              var giftCheckbox = giftContainer.find('input.gs__gift-checkbox');

              if ($('input.gs__gift-checkbox:checked').length) {
                  if(($('input.gs__to-msg').val() != "") && ($('input.gs__from-msg').val() != "") && ($('textarea.gs__msg').val() != "")) {
                      giftCheckbox.attr({"value": "yes", "name": "properties[gift]"});
                      $('input.gs__to-msg').attr({"name": "properties[To]"});
                      $('input.gs__from-msg').attr({"name": "properties[From]"});
                      $('textarea.gs__msg').attr({"name": "properties[Message]"});
                  } else {
                      return
                  }
              } else {
                  giftCheckbox.attr({"value": "", "name": ""});
                  $('input.gs__to-msg').attr({"name": ""});
                  $('input.gs__from-msg').attr({"name": ""});
                  $('textarea.gs__msg').attr({"name": ""});
              }
          }

        if (i.preventDefault(), "disabled" != $(this).attr("disabled"))
          if (theme.ajax_cart) {
              if (submitTimeout == true){
                  var att = $(this).closest("form").find("select[name=id]").val();
                  att || (att = $(this).closest("form").find("input[name=id]").val());
                  var qty = $(this).closest("form").find("input[name=quantity]").val();
                  qty || (qty = 1);
                  var props = {};
                  $('[name*="properties"]').each(function() {
                      var key = $(this).attr('name').split('[')[1].split(']')[0];
                      var value = $(this).val();
                if (value && key != 'gift') {
                      props[key] = value;
                }
                  });
              //validation
              let data = validateEngraving(props);
              let sellingPlan = $('input[name="selling_plan"]:checked').val();
              if (sellingPlan) {
                data.props['selling_plan'] = sellingPlan;
              }
              if (data.result) {
                  addinToCart(att, qty, data.props);
              } else {
                submitTimeout = true;
                return;
              }
                  //submitTimeout = true;
              } else {
                  return;
              }
          } else {
            $(".productForm").submit();
          }
          submitTimeout = false;
        return;
      });
    }
    function addinToCart(att, qty, props){
        // Hidden success modal LAG-173
  	    // $("body").addClass("loading showOverly");
      CartJS.addItem(att, qty, props,
      {
          "success": function(data, textStatus, jqXHR){
             $("#successDrawer").find(".modal-prod-img").attr("src",'');
             var pimg = data.image,
             	 pimg_path = pimg.replace(/(\.[^\.]*$|$)/, '_large' + '$&');
			 $("#successDrawer").find(".modal-prod-img").attr("src", pimg_path);
             $("#successDrawer").find(".modal-prod-name").text(data.product_title);

             // Hidden success modal LAG-173
              //$("#header-cart").addClass('cart-active');
              //$("html").addClass("cartOn");
             // $("body").removeClass("loading");
             // showDrawer("#successDrawer");
              submitTimeout = true;
          },
          "error": function(jqXHR, textStatus, errorThrown){
            var errormsg = JSON.parse(jqXHR.responseText).description;
            $("#header-cart").removeClass('cart-open');
            $("html").removeClass("cartOn");
            focusMiniCart(false);
            $("body").addClass("showOverly");
            // $("body").removeClass("loading");
            $(".error-message").text(errormsg);
            showDrawer("#errorDrawer");
          }
      });
    }
  	function showDrawer(i){
      $("body").addClass("loading showOverly");
      $(i).fadeIn(500);
    }
  	// function freeship() {
      	// var freeshipPrice = $(".freeShipMsg").attr('data-price'),
          //   freeshiptotal = freeshipPrice+'00'
          //   cartTotal = CartJS.cart.total_price,
      	// 	remainfreeship = freeshiptotal-cartTotal;
      	// if(remainfreeship>0){
      	// 	$("#freeShipMsg .freeShip").html(theme.Currency.formatMoney(remainfreeship, theme.moneyFormat));
          // 	$("#freeShipMsg").show();
          // 	if(theme.mlcurrency){
          // 		currenciesChange("#freeShipMsg .freeShip sapn.money");
          //   }

        // }
      	// else {
        // 	$("#freeShipMsg").hide().next().show();
		// }
  	// }
  	// $(document).on('cart.requestComplete', function(event, cart) {
    //     setTimeout(function(){ freeship(); }, 3000);
    // });
  	function wishlist() {
       var cookieName = "wishlistList";
       $(".add-to-wishlist").click(function(e){
           e.preventDefault();
             var id = $(this).attr('rel');
             if($.cookie(cookieName) == null) {
               var str = id;
             } else {
               if($.cookie(cookieName).indexOf(id) == -1) {
                 var str = $.cookie(cookieName) + '__' + id;
               }
             }
             $.cookie(cookieName, str, {expires:30, path:'/'});
             $(this).next(".loading-wishlist").css('display','block');
             $(this).hide();
             setTimeout(function(){
               $('.add-to-wishlist[rel="'+id+'"]').next(".loading-wishlist").hide();
               $('.added-wishlist[rel="'+id+'"]').css('display','block');
             }, 2000);
         })
     }
     function updateWishlist() {
       var cookieName = "wishlistList";
       try {
         if($.cookie(cookieName) != null && $.cookie(cookieName) != '__' && $.cookie(cookieName) != '') {
           var str = String($.cookie(cookieName)).split("__");
           for (var i=0; i<str.length; i++) {
             if (str[i] != '') {
               $('.added-wishlist[rel="'+str[i]+'"]').css('display','block');
               $('.add-to-wishlist[rel="'+str[i]+'"]').hide();
             }
           }
         }
       }
       catch (err) {}
     }
};
$(theme.ajaxCart);

$(document).ready(function() {
  var sections = new theme.Sections();

  sections.register('cart-template', theme.Cart);
  sections.register('product', theme.Product);
  sections.register('collection-template', theme.Filters);
  sections.register('collection-template', theme.collectionView);
  sections.register('product-template', theme.Product);
  sections.register('header-section', theme.HeaderSection);
  sections.register('map', theme.Maps);
  sections.register('slideshow-section', theme.SlideshowSection);
  sections.register('carousel', theme.carouselSection);
  sections.register('masonary', theme.masonary);
  sections.register('quotes', theme.Quotes);
  sections.register('instagram', theme.instagramSection);

  	// Show/Hide dropdown
   	$(".selected-currency").click(function() {
      $("#currencies").slideToggle();
   	});

    if($(window).width()>999) {
     $("#currencies li").click(function(){
  		$(this).parent().slideUp();
	});
    }

    desktopNavDropSize();
    navImageSlider();
    gridSectionSlider();
    mobileColumnsSlider();
    mobileColumnsSliderOro();
    swatchSlider(".swatches-carousel", 6);
    centeredSlickArrows('.carousel', '.grid-view-item__link, .image-container-box, .grid-view-item__image');

  $(document).on('swatches:render-complete', function(e, data) {
    //swatches:render-complete
    let blockId = data.toString();
    if (blockId == 'recently-viewed-products') {
            recentlyViewedSlider();
      jQuery(document).trigger('recentlyviewed:slider-complete',['recently-viewed-products']);
    }
  });

    // tabsCarouselUpdate();
    contactsSlider();
    customerCareSlider();
    heroSectionSlider();
    setTimeout(function(){
        if ($('.spr-reviews').length > 0) {
            $('.spr-reviews').slick({
                dots: true,
                arrows: true,
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: true,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                            infinite: true,
                            dots: true
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
        }
    },10000);

});

var resizeTimer;
  $(window).resize(function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      $(window).trigger('delayed-resize');
    }, 250);
});

theme.init = function() {
  theme.customerTemplates.init();

  slate.rte.wrapTable();
  slate.rte.iframeReset();

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  $('a[href="#"]').on('click', function(evt) {
    evt.preventDefault();
  });

};

$(theme.init);


/// Add to Cart Popup
! function($) {
  $(document).ready(function(){

    $(".saleTime").each(function(){
      var $this = $(this),
      	  date = $(this).data('date'),
      	  countDownDate = new Date(date).getTime();

		var x = setInterval(function(){
          var now = new Date().getTime(),
              distance = countDownDate - now,
              days = Math.floor(distance / (1000 * 60 * 60 * 24)),
              hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
              minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
              seconds = Math.floor((distance % (1000 * 60)) / 1000);

          if(days > 99){
            days = ("00" + days).substr(-3);
          } else {
            days = ("00" + days).substr(-2);
          }
          hours = ("00" + hours).substr(-2);
          minutes = ("00" + minutes).substr(-2);
          seconds = ("00" + seconds).substr(-2);

          $($this).find(".counter").html("<span class='days'>" + days + "<span>Days</span></span> <span class='hours'>" + hours + "<span>HR</span></span> <span class='minutes'>"+ minutes + "<span>MIN</span></span> <span class='seconds'>" + seconds + "<span>SC</span>");

          if (distance < 0){
          	clearInterval(x); $($this).hide();
		  }
		}, 1000);
  	});

	 $(".qtyBtn").on("click", function() {
      var qtyField = $(this).parent(".qtyField"),
         oldValue = $(qtyField).find(".qty").val(),
          newVal = 1;

      if ($(this).is(".plus")) {
        newVal = parseInt(oldValue) + 1;
      } else if (oldValue > 1) {
        newVal = parseInt(oldValue) - 1;
      }
      $(qtyField).find(".qty").val(newVal);
    });

  }), $(window).resize(function() {
    //ab.initMobileMenu()
  });

  // SHOW HIDE PRODUCT Filters
    $('.btn-filter').click(function(){
       $(".filterbar").toggleClass("active");
    });
    $('.closeFilter').click(function(){
      $(".filterbar").removeClass("active");
    });
  	// Hide Cart on document click
    $("body").click(function(event ){
      var $target = $(event.target);
      if(!$target.parents().is(".filterbar") && !$target.is(".btn-filter")){
        $(".filterbar").removeClass("active");
      }
    });

  // SHOW HIDE PRODUCT TAG

  $(".product-tags li").eq(10).nextAll().hide();

   $('.btnview').click(function(){
   	$(".product-tags li").not('.filter--active').show();
  	 $(this).hide();
  });

 // NEWSLETTER load one time on site load
  var date = new Date(),
      cookieSignup = "cookieSignup";

  if($("#newsletter-modal").length){
    var popupType = $("#newsletter-modal").attr("data-type"),
    	popupTime = $("#newsletter-modal").attr("data-time");
    if(popupType == 'pageload'){
        if($.cookie('cookieSignup') != 'true'){
          setTimeout( function(){
            $(".newsletter-wrap").fadeIn();
            $("#newsletter-modal").fadeIn();
          }, popupTime);
        }
    } else {
      $(document).on('mouseleave', leaveFromTop);
      function leaveFromTop(e){
        if( e.clientY < 0 && $.cookie('cookieSignup') != 'true'){
          $(".newsletter-wrap").fadeIn();
          $("#newsletter-modal").fadeIn();
        }
      }
    }
  }

  $(document).mouseup(function (e){
   	var container = $("#newsletter-modal");
    if (!container.is(e.target)
        && container.has(e.target).length === 0){
          container.hide();
          $(".newsletter-wrap").fadeOut();
    	}
	});

  $(".closepopup").click(function() {
    if($("#dontshow").prop("checked") == true){
    	$.cookie(cookieSignup, 'true', {expires:1, path:'/'});
	}
    $("#newsletter-modal").fadeOut();
    $(".newsletter-wrap").fadeOut();
  });

	if($(".notification-bar").length){
		if($.cookie('promotion') != 'true') {
    		$(".notification-bar").show();
  		}
  	}

  // LOOKBOOK SHOP
	$('.btn-shop').click(function(){
        $('html').addClass('lookOn');
       $('.products .grid-lb').not($(this).next()).removeClass('active');
    	$(this).next().addClass('active');
    	$(this).closest('.grid-section-box').addClass('active-products');
	});
	$('.btn-shop-close, .grid-lb .add-to-cart').click(function(){
        $('html').removeClass('lookOn');
    	$(this).closest('.grid-lb.grid-view-item').removeClass('active');
        $(this).closest('.grid-section-box').removeClass('active-products');
	});

  // PROMOTION HEADER show-hide
  $(".close-announcement").click(function() {
    $(".notification-bar").slideUp();
    $.cookie('promotion', 'true', { expires: 1});
  });

  // Cookie popup
  if($(".cookiePopup").length){
    if($.cookie('accept-cookies') != 'accepted'){
      setTimeout( function(){
        $(".cookiePopup").slideDown();
      }, 250);
    }
    $(".cookieBtn").click(function(){
      $(".cookiePopup").slideUp();
      $.cookie('accept-cookies', 'accepted', { expires:15, path:'/'});
    });
  }

  // User Links
   $('.site-header .user-menu').on('mouseover', function(){
       if($(this).hasClass('account-active')) {
           $(".customer-links-holder").slideUp('fast', function() {
               $(this).closest('.customer-link').removeClass('account-active')
           });
       } else {
           $(".customer-links-holder").slideDown('fast', function(){
               $(this).closest('.customer-link').addClass('account-active')
           });
       }
   });

    $('.site-header .customer-link').on('mouseleave', function(){
       $(".customer-links-holder").slideUp('fast', function() {
           $(this).closest('.customer-link').removeClass('account-active')
       });
   });
    $('.nav-footer').on('click', '.customer-link .user-menu ', function(event){
      event.preventDefault();
      $('.nav-footer .customer-links-holder ').slideToggle();

    });

    // window.onscroll = function(){ scrollFunction() };
	function scrollFunction() {
		// STICKY HEADER
        // $('.page-container').css("padding-top" , $('.header-wrap').outerHeight());

      	// STICKY Cart
      if($(".stickyCart .product-form__cart-submit, .stickyCart .gpr-form-cart").length){
      		var cartbtn;
          if($('.product-form__item--submit').length > 0) {
            cartbtn = $('.product-single .product-form__item--submit').offset();
          } else {
            cartbtn = $('.product-single .product-action').offset();
          }
          let currentVariant = $(".product-form__variants").val();
          if ($(".stickyCart select").length) {
              $(".stickyCart select").val(currentVariant);
          }

          if($(window).prop('innerWidth') > 767) {
              if($(window).scrollTop()>cartbtn.top){
                  $(".stickyCart").slideDown();
                  $(".stickyNav").addClass("sticky-cart-active")
                  $('.stickyCart .swatch-holder').removeClass('swatch-dropdown-open');
              }else {
                  $(".stickyCart").slideUp('fast', function (){
                      $(".stickyNav").removeClass("sticky-cart-active");
                  });
              }
          }

          }
        }

    function scrollHeader() {
      if (document.applyScrollHeader == 'undefined') {
        document.applyScrollHeader = false;
      }
      if(document.applyScrollHeader && $(window).prop('innerWidth') <= 767 ) {
        var st = window.pageYOffset || document.documentElement.scrollTop;
        if (st > lastScrollTop) {
          $('.mobile-search').hide();
        } else if (st < lastScrollTop) {
          $('.mobile-search').show();
        }
        lastScrollTop = st <= 0 ? 0 : st;
      }
    }

    let lastScrollTop = 0;

    $(document).on('scroll', function (){
        scrollFunction();
        scrollHeader();
    });

  //Footer links for mobiles
  $(".footer-links .h4").click(function() {
    if($(window).width() < 750){
      $(this).find(".ad").toggleClass("ad-angle-down-l ad-angle-up-l");
      $(this).next().slideToggle();
  	}
  });

  // SITE SCROLLER
  $("#site-scroll").click(function() {
    $("html, body").animate({ scrollTop: 0 }, 1000);
    return false;
  });

  $(window).scroll(function(){
  	if($(this).scrollTop()>300){
      $("#site-scroll").fadeIn();
    } else {
       $("#site-scroll").fadeOut();
    }

    if (theme.fixedHeader){
      // let headerPromo = $('.shopify-section .notification-bar');
      if($(window).scrollTop()> 0){
          $('.header-wrap').addClass("stickyNav animated");
          $('.page-container').css("padding-top" , $('.header-wrap').outerHeight());
      } else {
          $('.header-wrap').removeClass("stickyNav");
          $('.page-container').css("padding-top" , 0);
      }
    }
  });

   // Site Animation
  if(theme.animationMobile) {
      if($(window).width() < 767) {
          $('.wow').removeClass('wow');
      }
  }
  if(theme.animation) {
    new WOW().init();
  }

  /// Slieshow Parallax
  if($(".hero.parallax").length){
  	var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ? true : false;
  	if(!isMobile || $(window).width() > 767) {
    	$.stellar({ horizontalScrolling: false, verticalOffset: 40 });
  	}
  }

  const event = document.createEvent('Event');
  event.initEvent('shopifyOptionChange', true, true);

  jQuery(document).ready(()=>{
    jQuery("#personalized_enable").removeAttr("disabled")
  })

  jQuery(".swatchInput").change(()=>{
    window.shopifyPZoption = jQuery(".swatchInput:checked").val()
    document.dispatchEvent(event);
  });
  window.shopifyPZoption = jQuery(".swatchInput:checked").val()

  // Swatch aux
  swLog = function(product, handle = false, data)
  {
    if (!handle || product.handle == handle) {
      console.log('SW Log: ' + product.handle  +  ' ' + data);
    }
  }

  getDefaultSizeVariant = function(variants) {
    if (!variants?.length) {
      return;
    }

    const necklaceSizes = [
      '16',
      '18',
      '20',
      '22',
      '24',
      '32',
      '34',
      '36',
      '48',
    ];

    const isNecklaceProduct = necklaceSizes.includes(variants[0].title);

    const inStockVariants = variants
      .filter((variant) => variant?.inventory_quantity > 0 || variant?.available);

    // we return the smallest in stock variant if the product category is necklace
    if (isNecklaceProduct){
      return inStockVariants[0] || variants[0];
    }

    const defaultVariant = inStockVariants.reduce((defaultVariant, variant) => {
      const pValue = variant.title.toLowerCase();
      return pValue == '7' || pValue == 'm' || /medium(?!\+)/g.test(pValue)
        ? variant
        : defaultVariant;
    }, false);

    return defaultVariant
      || inStockVariants[Math.floor(inStockVariants.length / 2)]
      // if no in stock variant exists we return the middle most variant for OOS display
      || variants[Math.floor(variants.length / 2)];
  }


  getProductSwatchView = function(product)
  {
    let swatchViewData = '';
    let swatchView = '';
    for (let i = 0; i < product.tags.length; i++) {
      if (product.tags[i].startsWith('swatchView:')) {
        swatchViewData = product.tags[i].split(':');
        swatchView = swatchViewData[1];
      }
    }
    return swatchView;
  }
  getProductSubtitle = function(product)
  {
    let result = '';
    for (let i = 0; i < product.tags.length; i++) {
      if (product.tags[i].startsWith('sub_title:')) {
        let data = product.tags[i].split(':');
        result = data[1];
        break;
      }
    }
    return result;
  }
  getProductSwatchType = function(product)
  {
    let swatchType = 'gemstone';
    if (product.tags.includes('swatchView:symbol')) {
      swatchType = 'symbol';
    }    
    if (product.tags.includes('swatchView:phrase')) {
      swatchType = 'phrase';
    }
    return swatchType;
  }
  cleanupSwatchData = function(list)
  {
    let result = [];
    let usedIds = [];
    for (let i = 0; i < (list.length); i++) {
      if (list[i].id && !usedIds.includes(list[i].id)) {
        usedIds.push(list[i].id);
        result.push(list[i]);
      }
    }
    return result;
  }
  sortSwatchProducts = function(list)
  {
    if (list[0].handle && !list[0].handle.includes('initial-charm') && !list[0].handle.includes('zodiac-charm')) {
      return list;
    }
    let handles = [];
    for (let i = 0; i < (list.length); i++) {
      if (list[i].handle) {
        handles.push(list[i].handle);
      }
    }

    handles = sortSwatchProductHandles(handles);

    let result = [];
    for (let i = 0; i < (handles.length); i++ ) {
      for (let k = 0; k < (list.length); k++) {
        if (list[k].handle && (list[k].handle == handles[i])) {
          result.push(list[k]);
          break;
        }
      }
    }
    return result;
  }
  sortSwatchProductHandles = function(items)
  {
    let element = items[items.length - 1];

    let zodiac = ['aries','taurus','gemini','cancer','leo','virgo','libra','scorpio','sagittarius','capricorn','aquarius','pisces'];

    if (element.includes('initial-charm')) {
      //initial
      items.sort();
    }
    else if (element.includes('zodiac-charm')) {
      //zodiac

      let result = [];
      for (let i = 0; i < zodiac.length; i++) {
        for (let k = 0; k < items.length; k++) {
          if (items[k].includes(zodiac[i])) {
            result.push(items[k]);
            break;
          }
        }
      }
      items = result;
    } else {
      items.sort();
    }
    return items;
  }
  getProductSwatchName = function(product, stype, exclude=false, phraseOnly=false)
  {
    let name = '';
    let swatchView = getProductSwatchView(product);
    if (stype === 'phrase' && !phraseOnly) {
      return product.title
        .split(" ")
        .filter(el => el.toLowerCase() !== "signature" && el.toLowerCase() !== "caviar")
        .join(' ')
    }
    if (swatchView == 'gemstone' && stype == swatchView) {
      //exclude = false;
    }
    for (let i = 0; i < product.tags.length; i++) {
      if (product.tags[i].startsWith(stype + ':')) {
        let tag = product.tags[i].split(':');
        name = tag[1];
        if (exclude && (exclude.includes(name.toLowerCase()))) {
          continue;
        }
        if (name == '') {
          continue;
        }
        break;
      }
    }

    return name;
  }

  /**
   *
   * Gifting Update
   *
  **/

  // Mini cart
  const giftMessageLimit = 200;

  $('.mini-cart-gift-message-box .gift-message-box_add-button').click(function() {
    $('.mini-cart-gift-message-box .gift-message-box_popup').addClass('open');
  });

  $('.mini-cart-gift-message-box .gift-message-box_popup_content_save-button').click(function() {
    var orderNote = $('.mini-cart-gift-message-box .gift-message-box_popup_content_cart-note__input').val();

    $.ajax({
      url: '/cart/update.js',
      type: 'POST',
      data: {
        attributes: {
          'Message': orderNote
        }
      },
      dataType: 'json',
      success: function(result) {
        $('.mini-cart-gift-message-box .gift-message-box_content_message').html(orderNote);

        if(orderNote == '') {
          $('.mini-cart-gift-message-box .gift-message-box_add-button').show();
          $('.mini-cart-gift-message-box .gift-message-box_content_wrapper').hide();
        } else {
          $('.mini-cart-gift-message-box .gift-message-box_add-button').hide();
          $('.mini-cart-gift-message-box .gift-message-box_content_wrapper').show();
        }

        $('.mini-cart-gift-message-box .gift-message-box_popup').removeClass('open');
      },
      error: function(jqxhr, status, exception) {
          console.log(exception);
      }
    });
  });

  $('.mini-cart-gift-message-box .gift-message-box_popup_content_cancel-button').click(function() {
    $('.mini-cart-gift-message-box .gift-message-box_popup').removeClass('open');

    $('.mini-cart-gift-message-box .gift-message-box_popup_content_cart-note__input').val($('.mini-cart-gift-message-box .gift-message-box_content_message').text());
    $('.mini-cart-gift-message-box .gift-message-box_popup_content_characters-remaining_count').html(giftMessageLimit - $('.mini-cart-gift-message-box .gift-message-box_content_message').text().length);
  });

  $('.mini-cart-gift-message-box .gift-message-box_close').click(function() {
    $('.mini-cart-gift-message-box .gift-message-box_popup_content_cancel-button').click();
  });

  $('.mini-cart-gift-message-box .gift-message-box_content_edit-button').click(function() {
    $('.mini-cart-gift-message-box .gift-message-box_popup').addClass('open');
  });

  $(".mini-cart-gift-message-box .gift-message-box_popup_content_cart-note__input").keyup(function(){
    $(".mini-cart-gift-message-box .gift-message-box_popup_content_characters-remaining_count").text(giftMessageLimit - $(this).val().length);
  });

  $(document).on('cart.requestComplete', function(event, cart) {
    if(cart.item_count > 0) {
      $('.mini-cart-gift-message-box').addClass('active');
    } else {
      $('.mini-cart-gift-message-box').removeClass('active');
    }
  });

  // Cart Page
  $('.cart-gift-message-box .gift-message-box_add-button').click(function() {
    $('.cart-gift-message-box .gift-message-box_add-button').hide();
    $('.cart-gift-message-box .gift-message-box_popup').addClass('open');
  });

  $('.cart-gift-message-box .gift-message-box_popup_content_save-button').click(function() {
    var orderNote = $(this).parent().parent().find('.gift-message-box_popup_content_cart-note__input').val();

    $.ajax({
      url: '/cart/update.js',
      type: 'POST',
      data: {
        attributes: {
          'Message': orderNote
        }
      },
      dataType: 'json',
      success: function(result) {
        $('.cart-gift-message-box .gift-message-box_content_message').html(orderNote);

        if(orderNote == '') {
          $('.cart-gift-message-box .gift-message-box_add-wrapper').show();
          $('.cart-gift-message-box .gift-message-box_content_wrapper').hide();
          $('.cart-gift-message-box .gift-message-box_add-button').show();
        } else {
          $('.cart-gift-message-box .gift-message-box_add-wrapper').hide();
          $('.cart-gift-message-box .gift-message-box_content_wrapper').show();
        }

        $('.cart-gift-message-box .gift-message-box_content').show();

        $('.cart-gift-message-box .gift-message-box_popup').removeClass('open');
      },
      error: function(jqxhr, status, exception) {
        console.error(exception);
      }
    });
  });

  $('.cart-gift-message-box .gift-message-box_content_delete-button').click(function() {
    $.ajax({
      url: '/cart/update.js',
      type: 'POST',
      data: {
        note: ''
      },
      dataType: 'json',
      success: function(result) {
        $('.cart-gift-message-box .gift-message-box_content_message').html('');
        $('.cart-gift-message-box .gift-message-box_add-wrapper').show();
        $('.cart-gift-message-box .gift-message-box_content_wrapper').hide();
        $('.cart-gift-message-box .gift-message-box_content').show();
        $('.cart-gift-message-box .gift-message-box_add-button').show();
        $('.cart-gift-message-box .gift-message-box_popup_content_cart-note__input').val('');
        $('.cart-gift-message-box .gift-message-box_popup_content_characters-remaining_count').html(giftMessageLimit);
      },
      error: function(jqxhr, status, exception) {
        console.error(exception);
      }
    });
  });

  $('.cart-gift-message-box .gift-message-box_popup_content_cancel-button').click(function() {
    var cartNote = $('.cart-gift-message-box .gift-message-box_content_message').text();

    if(cartNote == '') {
      $('.cart-gift-message-box .gift-message-box_add-wrapper').show();
      $('.cart-gift-message-box .gift-message-box_popup').removeClass('open');

      $('.cart-gift-message-box .gift-message-box_popup_content_cart-note__input').val('');
      $('.cart-gift-message-box .gift-message-box_popup_content_characters-remaining_count').html(giftMessageLimit);
    } else {
      $('.cart-gift-message-box .gift-message-box_content').show();
      $('.cart-gift-message-box .gift-message-box_popup').removeClass('open');

      $('.cart-gift-message-box .gift-message-box_popup_content_cart-note__input').val($('.cart-gift-message-box .gift-message-box_content_message').text());
      $('.cart-gift-message-box .gift-message-box_popup_content_characters-remaining_count').html(giftMessageLimit - $('.cart-gift-message-box .gift-message-box_content_message').text().length);
    }

    $('.cart-gift-message-box .gift-message-box_add-button').show();
  });

  $('.cart-gift-message-box .gift-message-box_content_edit-button').click(function() {
    $('.cart-gift-message-box .gift-message-box_content').hide();
    $('.cart-gift-message-box .gift-message-box_popup').addClass('open');
  });

  $('.cart-gift-message-box .gift-message-box_popup_content_cart-note__input').keyup(function(){
    $(".cart-gift-message-box .gift-message-box_popup_content_characters-remaining_count").text(giftMessageLimit - $(this).val().length);
  });

  $('.cart-gift-message-box .gift-message-box_close').click(function() {
    $('.cart-gift-message-box .gift-message-box_popup_content_cancel-button').click();
  });


  // Packaging Update
  $('.mini-cart-packaging-view-button').click(function() {
    $('.packaging-popup').addClass('open');
  });

  $('.cart-packaging-view-button').click(function() {
    $('.packaging-popup').addClass('open');
  });

  $('.packaging-popup_option').click(function() {
    if(!$(this).hasClass('active')) {
      $('.packaging-popup_option').removeClass('active');
      $(this).addClass('active');

      var packaging = '';

      if($(this).hasClass('packaging-popup_option_separate')) {
        packaging = 'Separate';
      } else if($(this).hasClass('packaging-popup_option_single')) {
        packaging = 'Single';
      }

      $.ajax({
        url: '/cart/update.js',
        type: 'POST',
        data: {
          attributes: {
            'Packaging': packaging
          }
        },
        dataType: 'json',
        success: function(result) {
          console.log(result);
        },
        error: function(jqxhr, status, exception) {
            console.log(exception);
        }
      });
    }
  });

  $('.packaging-popup_close').click(function() {
    $('.packaging-popup').removeClass('open');
  });

  $('.packaging-popup_checkout-button').click(function() {
    window.location.href = '/checkout';
  });

  // Show/hide Packaging option in the mini cart when cart updates
  $(document).on('cart.requestComplete', function(event, cart) {
    if(cart.item_count < 2) {
      $('.mini-cart-packaging-container').removeClass('active');
    } else {
      $('.mini-cart-packaging-container').addClass('active');
    }
  });

}(jQuery);

// CMS aux
checkIsElementVisible = function(element) {
  let elPosition = $(element).offset();
  if (elPosition.top == 0) {
    return false;
  }
  if (elPosition && (($(window).scrollTop() + window.innerHeight) > elPosition.top)) {
    return true;
  }
  return false;
}

checkIsElementVisiblePredicted = function(element, pixels = 1000) {
  const predictionPixels = pixels;
  let elPosition = $(element).offset();
  if (typeof elPosition == 'undefined' || elPosition.top == 0) {
    return false;
  }
  if (elPosition && (($(window).scrollTop() + window.innerHeight + predictionPixels) > elPosition.top)) {
    return true;
  }
  return false;
}



!function ($) {
  // Function to build charm items with line-item properties in Cart
  const moneyFormat = '${{amount_no_decimals}}';
  const buildCharmItems = (cartItems) => {
    cartItems.forEach(({ item, item_components }, index) => {
      if (item_components.length) {
        const cartItemCharmsElement = [].slice.call(document.querySelectorAll(`[data-js-cart-item] [data-js-charm-items='${item.id}'][data-index='${index}']`));
        const mainProductTitle = item.product_title != item.collection_name ? item.product_title.replace(item.collection_name, '') : item.product_title
        let itemCharmsHtml = '';

        itemCharmsHtml += `
          <div class="cart-item__charm--edit" data-js-edit-charm>
            <span>Details</span>
            <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2 12L7 6.99933L2 2" stroke="black" stroke-width="2" stroke-linecap="square" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="cart-items__charms-list">
        `;

        item_components.forEach((charm) => {
          itemCharmsHtml += `
            <div class="cart-item__charm" data-variant-id="${charm.id}">
              <img class="cart-item__charm__image" src="${charm.image}" />
              <div class="cart-item__charm__info">
                <span class="cart-item__charm__title">${charm.product_title}${ charm.variant_title ? `: ${charm.variant_title}` : ''}</span>
                <span class="cart-item__charm__price">${Shopify.formatMoney(charm.price, moneyFormat)}</span>
              </div>
            </div>
          `;
        })

        itemCharmsHtml += `</div>`;

        if (cartItemCharmsElement.length > 0) {
          cartItemCharmsElement.forEach((element) => {
            element.innerHTML = itemCharmsHtml;

            let itemNoticeEl = '';
            const notice = 'Charm Builder Bracelet is a final sale. No returns or exchanges.'
            if (item.properties._product_type === 'bracelet') {
              itemNoticeEl = document.createElement("p");
              itemNoticeEl.className = 'line-item-notice';
              itemNoticeEl.append(notice);
              itemNoticeEl && element.prepend(itemNoticeEl);
            }
          })
        }

        const $editCharms = $('[data-js-edit-charm]');
        $editCharms.off('click');
        $editCharms.on('click', function() {
          const $charmWrapper = $(this).closest('.cart-item__charms-wrapper');
          const $charmsList = $charmWrapper.find('.cart-items__charms-list');
          $charmWrapper.toggleClass('open');
          $charmsList.slideToggle();
        })
      }
    })
  };

  const renderMiniCart = (cart) => {
    let totalQty = cart.item_count;
    cart.items.forEach((item, index) => {
      if (item.properties.charms) {
        // Update line price of mini cart items.
        const linePriceElements = [].slice.call(document.querySelectorAll(`[data-js-cart-item] [data-js-line-price='${item.id}'][data-index='${index}']`));
        let linePrice = Shopify.formatMoney(item.properties._bundlePrice * item.quantity, moneyFormat);
        if (linePriceElements.length > 0) {
          linePriceElements.forEach((element) => {
            element.innerHTML = linePrice
          })
        }
      }

      if (item.properties._bundledImage) {
        const imageElements = [].slice.call(document.querySelectorAll(`[data-js-cart-item] [data-js-line-image='${item.id}'][data-index='${index}']`));
        if (imageElements.length > 0) {
          imageElements.forEach((element) => {
            element.src = item.properties._bundledImage
          })
        }
      }

      const miniCartRow = document.querySelector(`.mini-cart__row[data-js-cart-item][data-index='${index}']`);

      if (item.properties._charmBuilderItem) {
        // Hide charm item
        miniCartRow.classList.add('hide')

        // Reduce quantity
        totalQty = totalQty - item.quantity;
      } else {
        // Show minicart Row if it's not Charm item
        miniCartRow.classList.remove('hide')
      }
    });

    // Update Cart quantity
    setTimeout(() => {
    const cartCountElements = [].slice.call(document.querySelectorAll('[data-js-cart-count]'));
    cartCountElements.forEach((element) => {
      element.innerHTML = totalQty;
    })
    }, 300);
    // Calculate the cart total
    let cartTotalValue = 0;
    cart.items.forEach((item) => {
        if(item.line_price) {
            cartTotalValue += item.line_price;
        }
    });

    // Convert the cart total value from cents to dollars
    let cartTotalDollars = cartTotalValue / 100;

    // Update the progress bar and message based on cart value
    const progressBar = document.getElementById("shippingProgress");
    const progressContainer = document.getElementById("progressContainer");
    const shippingMessageElement = document.getElementById("shippingMessage");

    if (cartTotalDollars > 1) { // Show logic only if cart total is over $1
      // Show the progress bar and message
      progressContainer.style.display = "flex";
      progressBar.style.display = "block";
      shippingMessageElement.style.display = "block";

      // Update the progress bar and message based on cart value
      progressBar.value = cartTotalDollars;

      if(cartTotalDollars < 100) {
          const amountLeft = 100 - cartTotalDollars;
          shippingMessageElement.textContent = `You have $${amountLeft.toFixed(2)} until Complimentary Shipping`;
      } else {
          shippingMessageElement.textContent = theme.strings.miniCartMsg;
      }
  } else {
      // Hide the progress bar and message if cart total is $1 or less
      progressBar.style.display = "none";
      progressContainer.style.display = "none";
      shippingMessageElement.style.display = "none";
  }
  }

  const handleCartChangeItem = (line, quantity, callback) => {
    jQuery.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=' + quantity + '&line=' + line,
      dataType: 'json',
      beforeSend: function() {
        $(document).trigger('beforeChangeItem.ajaxCart', [line, quantity]);
      },
      success: function(cart) {
        if ((typeof callback) === 'function') {
          callback(cart);
        }
        // $(document).trigger('afterChangeItem.ajaxCart', [line, quantity, cart]);
      },
    });
  }

  const handleCartUpdateItem = (data, triggeredFrom = 'minicart') => {
    jQuery.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: data,
      dataType: 'json',
      success: function() {
        if (triggeredFrom === 'minicart') {
          CartJS.getCart();
        } else {
          location.reload();
        }
      }
    });
  }

  const handleRemoveButtonClick = ($cartItem) => {
    let triggeredFrom = '';
    if ($cartItem.hasClass('mini-cart__row')) {
      triggeredFrom = 'minicart';
    } else {
      triggeredFrom = 'cart_page';
    }

    const index = parseInt($cartItem.data('index'));

    // If normal item
    handleCartChangeItem(index + 1, 0, function() {
      if (triggeredFrom === 'minicart') {
        CartJS.getCart();
      } else {
        location.reload();
      }
    });
  }

  const hasItemWithComponents = items => items.some(item => item.has_components);
  let currentRequestId = 0;

  const buildAndRenderCart = (cart) => {
    currentRequestId++;
    const requestId = currentRequestId;
    if (!hasItemWithComponents(cart.items)) {
      renderMiniCart(cart);
      return;
    }
    fetch(`/cart?view=json`)
      .then(res => res.json())
      .then(cartData => {
        // Toss this data if there's a newer request in progress
        if (requestId !== currentRequestId) return;

        buildCharmItems(cartData.items);
        renderMiniCart(cart);
      });
  };

  $(document).ready(function () {
    if (typeof CartJS !== 'undefined' && typeof CartJS.cart !== 'undefined' && typeof CartJS.cart.items !== 'undefined' && CartJS.cart.items.length > 0) {
      buildAndRenderCart(CartJS.cart);
      //renderMiniCart(CartJS.cart);
    }

    $(document).on('click', '[data-js-cart-item-remove]', function(e) {
      e.preventDefault();
      const $cartItem = $(this).closest('[data-js-cart-item]');
      handleRemoveButtonClick($cartItem);
    })
  });

  $(document).on('cart.requestComplete', function(event, cart) {
    $('.mini-cart__row [data-js-charm-items]').html('');
    buildAndRenderCart(cart);
    //renderMiniCart(cart);
  });
}(jQuery);

window.addEventListener('searchspring.domReady', function () {
  let waitForPlpTilesIntervals = null;
  waitForPlpTilesIntervals = setInterval(waitForPlpTiles, 250);
  function waitForPlpTiles() {
    if ($('[id^=collectionsall]').length > 0) {
      let lastTile = $('[id^=collectionsall]').first();
      let href = lastTile.find('.link-to-product').attr('href');
      //process
      if (href) {
        clearInterval(waitForPlpTilesIntervals);
        $(document).trigger('catalog-tiles:render-complete');
      }
    }
  }

}, false);

window.addEventListener('searchspring.domReady', function () {
  function preloadGallery(productTile) {
    let productHandle = $(productTile).find('.link-to-product').attr('href').split('/').pop();
    productHandle = productHandle.split('?').shift();
    let imageData = plpGalleryData[productHandle];
    let img = $(productTile).find('img.hover').first();
    let sizes = $(img).attr('sizes');
    for (let i=0; i<imageData.length; i++) {
      let variantImageSrcset =
        theme.Images.getSizedImageUrl(imageData[i], '180x') + ' ' + 180 + 'w,'
          + theme.Images.getSizedImageUrl(imageData[i], '360x') + ' ' + 360 + 'w,'
          + theme.Images.getSizedImageUrl(imageData[i], '540x') + ' ' + 540 + 'w,'
          + theme.Images.getSizedImageUrl(imageData[i], '720x') + ' ' + 720 + 'w,'
          + theme.Images.getSizedImageUrl(imageData[i], '900x') + ' ' + 900 + 'w,'
          + theme.Images.getSizedImageUrl(imageData[i], '1080x') + ' ' + 1080 + 'w'
      ;
      let imgUrl = imageData[i];
      let preloadLink = '<link rel="preload" id=link-"' + productTile.id + '-' + i +'" as="image" href="'+ imgUrl +'" imagesrcset="' + variantImageSrcset + '" imagesizes="' + sizes + '">';
      if ($('#link-' + productTile.id + '-' + i).length == 0) {
        $('head').append(preloadLink);
      }
    }
  }

  function scrollPlpSlide(productTile, next = true, scrollToStart = false) {

    let curSlide = $(productTile).attr('data-gcur');
    let scrollToSlideNum = 0;
    if (next) {
      scrollToSlideNum = parseInt(curSlide) + 1;
    } else {
      scrollToSlideNum = parseInt(curSlide) - 1;
    }

    let productHandle = $(productTile).find('.link-to-product').attr('href').split('/').pop();
    productHandle = productHandle.split('?').shift();
    let imageData = plpGalleryData[productHandle];
    if (!imageData) return;

    if (scrollToSlideNum < 0) {
      scrollToSlideNum = imageData.length - 1;
    }
    if (scrollToSlideNum >= imageData.length) {
      scrollToSlideNum = 0;
    }
    if (scrollToStart) {
      scrollToSlideNum = 0;
    }

    let variantImageSrcset =
      theme.Images.getSizedImageUrl(imageData[scrollToSlideNum], '180x') + ' ' + 180 + 'w,'
        + theme.Images.getSizedImageUrl(imageData[scrollToSlideNum], '360x') + ' ' + 360 + 'w,'
        + theme.Images.getSizedImageUrl(imageData[scrollToSlideNum], '540x') + ' ' + 540 + 'w,'
        + theme.Images.getSizedImageUrl(imageData[scrollToSlideNum], '720x') + ' ' + 720 + 'w,'
        + theme.Images.getSizedImageUrl(imageData[scrollToSlideNum], '900x') + ' ' + 900 + 'w,'
        + theme.Images.getSizedImageUrl(imageData[scrollToSlideNum], '1080x') + ' ' + 1080 + 'w'
    ;

    let img = $(productTile).find('img.hover').first();
    let imgUrl = imageData[scrollToSlideNum];

    $(productTile).attr('data-gcur',scrollToSlideNum);
    $(img).attr('src',imgUrl);
    $(img).attr('srcset',variantImageSrcset);
  }

  function scrollPlpSlideMobile(productTile, next = true, scrollToStart = false) {
    let curSlide = parseInt(
      $(productTile).attr('data-gcur-mob')
    );
    let scrollToSlideNum = 0;
    let img = $(productTile).find('img.hover').first();
    const defaultImg = $(productTile).find('.grid-view-item__image.primary').first();
    let imgUrl = defaultImg.attr('src');
    let variantImageSrcset = defaultImg.attr('srcset');
    let productHandle = $(productTile)
      .find('.link-to-product')
      .attr('href')
      .split('/')
      .pop()
      .split('?')
      .shift();

    if (next) {
      scrollToSlideNum = curSlide + 1;
    } else {
      scrollToSlideNum = curSlide - 1;
    }

    if (scrollToStart) {
      scrollToSlideNum = 0;
    }

    const imageData = plpGalleryData[productHandle];
    if (imageData) {
      if (scrollToSlideNum > imageData.length) {
        scrollToSlideNum = 0;
      }
      if (scrollToSlideNum < 0) {
        scrollToSlideNum = imageData.length - 1;
      }

      if (scrollToSlideNum !== 0) {
        imgUrl = imageData[scrollToSlideNum - 1];
        variantImageSrcset =
          theme.Images.getSizedImageUrl(imgUrl, '180x') + ' ' + 180 + 'w,'
            + theme.Images.getSizedImageUrl(imgUrl, '360x') + ' ' + 360 + 'w,'
            + theme.Images.getSizedImageUrl(imgUrl, '540x') + ' ' + 540 + 'w,'
            + theme.Images.getSizedImageUrl(imgUrl, '720x') + ' ' + 720 + 'w,'
            + theme.Images.getSizedImageUrl(imgUrl, '900x') + ' ' + 900 + 'w,'
            + theme.Images.getSizedImageUrl(imgUrl, '1080x') + ' ' + 1080 + 'w'
        ;
      }
    }

    $(productTile).attr('data-gcur-mob', scrollToSlideNum);
    $(img).attr('src', imgUrl);
    $(img).attr('srcset', variantImageSrcset);
  }

  // TODO: consider loading using JS to hide/show primary vs gallery image on first load here 
  // (ie. in mutation observer) rather than (or in addtion to) explcit css rule to mask inital 
  // loading of mobile gallery.
  function determinePlpSlideScroll(productTile, next = true, scrollToStart = false) {
    const executeScroll = () => {
      if (window.innerWidth > window.theme.mobileBreakpoint) {
        scrollPlpSlide(productTile, next, scrollToStart);
      } else {
        scrollPlpSlideMobile(productTile, next, scrollToStart);
      }
      // toggleMobileView(productTile);
    }

    const checkForLazyLoad = () => {
      const hoverImg = productTile.querySelector(".grid-view-item__image.hover");
      if (!hoverImg) return;
      if (hoverImg?.classList?.contains('lazyloaded')) {
        executeScroll();
      } else {
        const hoverObserver = new MutationObserver((mutations) => {
          mutations.forEach(mutation => {
            if (mutation.attributeName === "class" && hoverImg.classList.contains('lazyloaded')) {
              executeScroll();
              hoverObserver.disconnect();
            }
          })
        });
        hoverObserver?.observe(hoverImg, {attributes: true})
      }
    }

    const checkForPrimaryImg = () => {
      const primaryImg = productTile.querySelector(".grid-view-item__image.primary");
      if ($(productTile).attr('data-primary-rendered') == 1) {
        checkForLazyLoad();
      } else {
        const primaryObserver = new MutationObserver((mutations) => {
          mutations.forEach(mutation => {
            if (mutation.attributeName === "src") {
              checkForLazyLoad();
              $(productTile).attr('data-primary-rendered', 1);
              primaryObserver.disconnect();
            }
          })
        });
        primaryObserver.observe(primaryImg, {attributes: true})
      }
    }

    checkForPrimaryImg();
  }

  function toggleMobileView(productTile) {
    const primaryImg = productTile.querySelector(".grid-view-item__image.primary");
    const hoverImg = productTile.querySelector(".grid-view-item__image.hover");
    if (window.innerWidth <= window.theme.mobileBreakpoint) {
      primaryImg.style.opacity = '0';
      primaryImg.style.visibility = 'hidden';
      hoverImg.style.opacity = '1';
      hoverImg.style.visibility = 'visible';
    } else {
      primaryImg.style.opacity = '';
      primaryImg.style.visibility = '';
      hoverImg.style.opacity = '';
      hoverImg.style.visibility = '';
    }
  }

  function handleGalleryMobileDesktopToggle() {
    const crossedDesktop = () => 
      window.innerWidth >= window.theme.mobileBreakpoint 
      && window.theme.prevWidth <= window.theme.mobileBreakpoint;
    const crossedMobile = () =>
      window.innerWidth <= window.theme.mobileBreakpoint
      && window.theme.prevWidth >= window.theme.mobileBreakpoint;
    window.addEventListener("resize", () => {
      if (crossedDesktop() || crossedMobile()) {
        $('[id^=collectionsall]').each((_index , element) => {
          // toggleMobileView(element);
          determinePlpSlideScroll(element, true, true);
          if (crossedDesktop()) {
            toggleMobileView(element);
          }
        });
      } 
      window.theme.prevWidth = window.innerWidth;
    });
  }

  function observeHrefChange(productTile) {
    let targetNode = productTile;
    let config = { attributes: true, childList: true, subtree: true };

    let callback = function(mutationsList, _observer) {
      for(let mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName == 'href') {
          let elClass = $(mutation.target).attr('class');
          let href = $(mutation.target).attr('href');
          if (elClass.includes('link-to-product')) {
            let productHandle = href.split('/').pop();
            productHandle = productHandle.split('?').shift();
            if ((typeof plpGalleryData[productHandle] === 'undefined') && $(productTile).attr('data-gset') == 1) {
              checkPreloadGalleryStatic(productTile, productHandle);
            }
            determinePlpSlideScroll(productTile, true, true);
            //$(productTile).attr('data-gset', 0);
          }
        }
      }
    };

    let observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
  }



  function handleSwipeGesture(productTile) {
    if (touchendX < touchstartX) {
      handlePlpItemSlideLeft(productTile);
    }
    if (touchendX > touchstartX) {
      handlePlpItemSlideRight(productTile);
    }
  }

  function handlePlpItemSlideLeft(productTile) {
    toggleMobileView(productTile);
    determinePlpSlideScroll(productTile, false);
  }

  function handlePlpItemSlideRight(productTile) {
    toggleMobileView(productTile);
    determinePlpSlideScroll(productTile, true);
  }

  function checkPreloadGalleryStatic(productTile, productHandle) {
    const images = JSON.parse(jQuery(productTile).attr('data-gallery'));
    if (images && images.length) {
      let primaryImage = $(productTile).find('img.primary')[0];
      let galleryItems = [];
      for (let i=1; i < images.length; i++) {

        imgSrc = images[i].src;
        if (!imgSrc.includes('Charm')) {
          galleryItems.push(imgSrc);
        }
      }

      plpGalleryData[productHandle] = galleryItems;
      let visualContainer = $(primaryImage).closest('.grid-view_image');

      if ($(productTile).find('button.prev-btn').length == 0) {
        let btnPrev = document.createElement("button");
        $(btnPrev).addClass('plp-btn prev-btn').html('<span class="plp-btn-icon" aria-hidden="true"></span><span class="visually-hidden">Previous image</span>');

        let btnNext = document.createElement("button");
        $(btnNext).addClass('plp-btn next-btn').html('<span class="plp-btn-icon" aria-hidden="true"></span><span class="visually-hidden">Next image</span>');

        visualContainer.append(btnPrev, btnNext);

        $(btnNext).click(function() {
          handlePlpItemSlideRight(productTile);
        });

        $(btnPrev).click(function() {
          handlePlpItemSlideLeft(productTile);
        });
      }

      productTile.addEventListener('touchstart', function (event) {
        touchstartX = event.changedTouches[0].screenX;
        touchstartY = event.changedTouches[0].screenY;
      }, false);

      productTile.addEventListener('touchend', function (event) {
        touchendX = event.changedTouches[0].screenX;
        touchendY = event.changedTouches[0].screenY;
        handleSwipeGesture(productTile);
      }, false);

      preloadGallery(productTile);
    }
  }

    function plpSlidersInit() {
      $('[id^=collectionsall]').each(function(_index , _element) {
        observeHrefChange(this);
      });
      document.addEventListener('lazybeforeunveil', (e) => {
        const productTile = e.target.closest(".grid__item");
        if (!$(productTile).attr('data-gset')) {
          const prodUrl = $(productTile).find('.link-to-product').attr('href');
          if (!prodUrl) {
            return;
          }
          let productHandle = prodUrl.split('/').pop();
          // let productHandle = $(productTile).find('.link-to-product').attr('href').split('/').pop();
          $(productTile).attr('data-gset', 1);
          $(productTile).attr('data-gcur', 0);
          $(productTile).attr('data-gcur-mob', 0);
          checkPreloadGalleryStatic(productTile, productHandle);
          determinePlpSlideScroll(productTile, true, true);
      }
    });
  }


  plpSlidersInit();
  handleGalleryMobileDesktopToggle();
}, false);

// DY Banners
$(document).on("dy:render-complete", function(_event, data) {
  let blockData = data;
  
  if (typeof blockData == 'object') {
    initDySlider(blockData[0], blockData[1]);
    handleBuildSwatches(blockData[0]);
  } else {
    initDySlider(blockData);
    handleBuildSwatches(blockData);
  }
  if (blockData[1] !== undefined && blockData[1]['type'] !== undefined) {
    if (blockData[1]['type'] == 'plp-inline-ad' && blockData[1]['position']) {
      //register PLP block
      let block = $('.' + blockData[0]).first().parent().parent();
      plpBanners.push({
            'block' : block,
            'position' : blockData[1]['position']
          }
      );
    }
  }
});

let buildPlpPlaceholders = function() {
  if (typeof plpPlaceholdersBuilt == 'undefined') {
    return;
  }
  if (plpPlaceholdersBuilt) {
    return;
  }
  plpPlaceholdersBuilt = true;
  const container = $('#plp-placeholders');
  for (let i=1; i <=48; i++) {
    $("<div id='plp-placeholder-" + i + "' style='display:none'></div>").appendTo(container);
  }
  /*
  plpSlots.each(function( index , element) {
    $("<div id='plp-placeholder-" + (index + 1) + "' style='display:none'></div>").insertAfter(element);
  });
  */
}

let processPlpPlaceholders = function() {
  if (typeof plpPlaceholdersBuilt == 'undefined') {
    return;
  }
  let plpSlots = $('[id^=collectionsall]');
  if (plpPlaceholdersBuilt) {
    plpSlots.each(function( index , element) {
      $('#plp-placeholder-' + (index + 1)).insertAfter(element);
    });
    return;
  }

}

window.addEventListener('searchspring.domReady', function () {
  processPlpPlaceholders();
  if (typeof plpBanners == 'undefined') {
    return;
  }
  if (($('.ss-pagination').find('.ss-page').length != 1) && (plpBanners.length != 0)
      && ($('.ss-pagination').find('.ss-active span').html() != '1')) {
      plpBanners.forEach((item) => {
        $(item.block).hide();
      });
  }
  if (($('.ss-pagination').find('.ss-page').length != 1) && (plpBanners.length != 0)
      && ($('.ss-pagination').find('.ss-active span').html() == '1')
      || $('.ss-pagination').find('.ss-page').length == 1) {
      //reset positions
      plpBanners.forEach((item) => {
        let currentPlaceholder = $('#plp-placeholder-' + (parseInt(item.position) - 1));
        $(item.block).insertAfter(currentPlaceholder);

        let prevId = $(currentPlaceholder).prev().attr('id');
        if (prevId.includes('plp-placeholder-')) {
          $(item.block).hide();
        } else {
        $(item.block).show();
        }
      });
    }

}, false);

// Accessibly functions
focusMiniCart = function(active = true, passFocus = true) {
  window.minicartTriggered = true;
  $(document).trigger('header:minicart-focus');
  if ($("#header-cart").hasClass('cart-open')) {
    $("#header-cart").attr('aria-hidden',false);
  } else {
    $("#header-cart").attr('aria-hidden',true);
  }
  if (!passFocus) {
    return;
  }
  if (active) {
    setTimeout(() => {
      $("#header-cart").find('.cart-title').first().click();
      $("#header-cart").find('.cart-title').first().focus();
    }, 1000);
  } else {
    if (false) {
      //$('.skip-link').first().focus();
      $('#siteNav').find('a').first().focus();
    } else {
      $('.site-header__cart').first().focus();
    }
  }
}

$(document).on("catalog-toolbar:render-complete", function(event, data) {
  const toolbarPLP = $('#searchspring-content .productList');
  let resultsCountUpdated = false;
  if(!$('#searchspring-content .toolbar-placeholder').length) {
    toolbarPLP.prepend('<div class="toolbar-placeholder"></div>');
  }
  stickyPlpFiltersInit();


  $(document).on('scroll', function (){
    stickyPlpFiltersInit();
  });

  if (true || window.innerWidth <= 515) {
    let counter = 0;
    let activeElement = 1;
    $('.ss-page').each(function( index ) {
      counter += 1;
      if ($(this).attr('style') == 'display: block;') {
        $(this).attr('style', 'display: inline-block;');
      }
      if ($(this).hasClass('ss-active')) {
        activeElement = counter;
        if (window.innerWidth <= 515) {$('html, body').scrollTop(0);}
      }
      if ($(this).hasClass('ss-page-hellip')) {
        $(this).hide();
        if (counter <= 3) {
          $(this).prev().hide();
        } else {
          $(this).next().hide();
        }
      }
    });

    if ($('.ss-page').length >= 7) {
      $('.ss-page').addClass('ss-p-thin');
    }
  } else {
  }

  function updateResultsCount() {
    if (resultsCountUpdated) {
      return;
    }
    resultsCountUpdated = true;
    let plpSlots = $('[id^=collectionsall]');
    let page = 1;
    if ($('.ss-pagination').find('.ss-page').length != 1) {
      let curPage = $('.ss-pagination').find('.ss-active span').html();
      curPage = parseInt(curPage);
      if (curPage != 0 && curPage != 1) {
        page = curPage;
      }
    }
    const start = (page-1) * 48 + 1;
    const end = start + plpSlots.length - 1;
    $('#result-count').remove();
    $('.ss__header__result--count').prepend('<span id="result-count">Showing ' + start + ' - ' + end + '&nbsp;of&nbsp;' + '</span>');
  }
  function stickyPlpFiltersInit() {
    if(($(window).scrollTop() + $('.header-wrap').outerHeight()) > toolbarPLP.offset().top){
      $('body').addClass('stick-filter-active');
      $('#searchspring-content .toolbar-placeholder').css('height', ($('.productList .toolbar.ng-scope').outerHeight()))
    } else {
      $('body').removeClass('stick-filter-active');
      $('#searchspring-content .toolbar-placeholder').css('height', 0);
    }
  }
});

// Look aux
function getProductCollectionName(product) {
  let collectionName = product.tags.find(item => item.includes('collection_name:'));
  if (collectionName) {
    collectionName = collectionName.replace('collection_name:', '');
  } else {
    collectionName = product.title;
  }
  return collectionName;
}

function getProductSubTitle(product) {
  let subTitle = product.tags.find(item => item.includes('sub_title:'));
  if (subTitle) {
    subTitle = subTitle.replace('sub_title:', '');
  } else {
    subTitle = '';
  }
  return subTitle;
}

function getProductBadge(product) {
  let badge = "";
  let cBadge = false;
  if (badge == "") {
    cBadge = product.tags.find(item => item == 'category_node_:Exclusive');
    if (cBadge) {
      badge = "Exclusive";
    }
  }
  if (badge == "") {
    cBadge = product.tags.find(item => item == 'category_node_:Engraving');
    if (cBadge) {
      badge = "Engrave";
    }
  }
  if (badge == "") {
    cBadge = product.tags.find(item => item == 'category_node_:Best Sellers');
    if (cBadge) {
      badge = "Best Seller";
    }
  }
  if (badge == "") {
    cBadge = product.tags.find(item => item == 'category_node_:New Arrivals');
    if (cBadge) {
      badge = "New";
    }
  }
  return badge;
}

$(document).on("catalog-tiles:render-complete", function(event, data) {
  let plpSlots = $('[id^=collectionsall]');
  plpSlots.each(function( index , element) {
    if ($(element).attr('data-rating')) {
      let ratingStr = $(element).attr('data-rating');
      if (ratingStr && $(element).find('div.jdgm-prev-badge').length == 0) {
        let rating = $.parseHTML(ratingStr);
        let score = $(rating).find('.jdgm-prev-badge__stars').attr('data-score');
        if (score != '0.00') {
          $(element).find('.link-to-product').last().append(rating);
        }
        $(rating).show();
      }
    }
  });
});
class PdpStockHelper {
  constructor(variantStockData, currentProductVariants) {
    this.variantStockData = variantStockData;
    this.currentProductVariants = currentProductVariants;
  }
  getVariantStockByTitle(elText) {
    let result = false;
    if (this.variantStockData[elText]) {
      return this.variantStockData[elText];
    }
    return result;
  }
  getBestInStockVariant(defaultVariantTitle) {
    let variant = this.getBetterInStockVariant(defaultVariantTitle);
    if (!variant) {
      variant = this.getFirstInStockVariant();
    }
    return variant;
  }
  getBetterInStockVariant(defaultVariantTitle) {
    let result = false;
    for (var i = 0; i < this.currentProductVariants.length; ++i) {
      if (this.currentProductVariants[i].title == defaultVariantTitle) {
        break;
      }
    }
    for (var i = i+1; i < this.currentProductVariants.length; ++i) {
      let currentVariant = this.currentProductVariants[i];
      if (this.variantStockData[currentVariant.title] && (this.variantStockData[currentVariant.title].qty != 0)) {
        result = currentVariant;
        result.qty = this.variantStockData[currentVariant.title].qty;
        return result;
      }
    }
    return result;
  }
  getFirstInStockVariant() {
    let result = false;
    for (var i = this.currentProductVariants.length -1; i >= 0; --i) {
      let currentVariant = this.currentProductVariants[i];
      if (this.variantStockData[currentVariant.title] && (this.variantStockData[currentVariant.title].qty != 0)) {
        result = currentVariant;
        result.qty = this.variantStockData[currentVariant.title].qty;
        return result;
      }
    }
    return result;
  }
  getNoStockAvailableVariant() {
    const defaultIdx = Math.floor(this.currentProductVariants.length / 2);
    return this.currentProductVariants[defaultIdx];
  }
}

$(window).on('load resize orientationchange', function() {
  $('.imgBnrOuter .grid').each(function(){
    var $carousel = $(this);
    if ($(window).width() > 767) {
      if ($carousel.hasClass('slick-initialized')) {
        $carousel.slick('unslick');
      }
    }
    else{
      if (!$carousel.hasClass('slick-initialized')) {
        $carousel.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          mobileFirst: true,
        });
      }
    }
  });
});

//Performance updates

uncommentScript = function (el) {
    $(el)
      .contents()
      .filter(function(){return this.nodeType === 8;})
      .replaceWith(function(){return this.data;})
}

attachMinicartPaymentButtonsExt = function () {
  uncommentScript($('#minicart-payment-buttons'));
}

$(document).on('header:minicart-focus', function () {
  if (!minicartPaymentButtonsAttached) {
    minicartPaymentButtonsAttached = true;
    attachMinicartPaymentButtonsExt();
  }
});

addToCartDefaultVariant = function (handle, eventObj = false) {
  jQuery.getJSON('/products/' + handle +'.js', function(product) {
    let foundVariant = product.variants[0];
    if (product.options.size == 1 && product.variants[0].title == 'Default Title') {
      //product with no options
    } else {
      const currentProductVariants = product.variants;
      product.variants.forEach(function(variant) {
        if (!foundVariant) {
          foundVariant = variant;
        }
        const pValue = variant.title.toLowerCase();
        if (pValue == 7 || pValue == 'm' || /medium(?!\+)/g.test(pValue)) {
          foundVariant = variant;
        }
      });
    }
    // Check if we are on the /cart page
    if (window.location.pathname.includes('/cart')) {
      function addVariantToCart(variantId, quantity) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: variantId,
            quantity: quantity,
          }),
        })
        .then(response => response.json())
        .then(data => {
          window.location.href = '/cart';

        })
        .catch((error) => {
          console.error('===========CART ITEM Error:', error);
        });
      }
      addVariantToCart(foundVariant.id, 1);
    } else {
      // If we are not on the /cart page, use the regular CartJS function
      CartJS.addItem(foundVariant.id);
    }
    if (eventObj) {
      eventObj.properties.productId = foundVariant.id;
      DY.API("event", eventObj);
    }
  });
}



let zendeskLazyOnload = function () {
  let zeIntervals = null;
  zeIntervals = setInterval(waitZe, 500);
  function waitZe() {
    if ((typeof zE !== 'undefined') && (typeof zE.activate !== 'undefined')) {
      clearInterval(zeIntervals);
      //process
      $('#zendesk-lazy').hide();
      zE.activate();
    }
  }
}

